var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViasights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16279",
    "data-name": "Group 16279",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.645,
    height: 43.399,
    viewBox: "0 0 152.645 43.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21308",
    "data-name": "Path 21308",
    d: "M2330.455,321.3h2.8l9.042,24.352,9.088-24.352h2.812l-10.769,28.572h-2.211L2330.455,321.3Zm25.4,28.572v-21.58h2.775v21.58Zm25.486-10.94a8.384,8.384,0,0,0-2.458-5.992,7.606,7.606,0,0,0-5.653-2.557,7.882,7.882,0,0,0-5.923,2.557,8.859,8.859,0,0,0-2.442,6.35,8.354,8.354,0,0,0,2.436,6.088,7.9,7.9,0,0,0,5.849,2.482,7.616,7.616,0,0,0,5.748-2.616,8.954,8.954,0,0,0,2.444-6.312Zm0,7.517a8.833,8.833,0,0,1-3.5,2.927,10.92,10.92,0,0,1-4.754,1.057,10.579,10.579,0,0,1-7.911-3.246,11.771,11.771,0,0,1,.065-16.124,10.909,10.909,0,0,1,8.077-3.253,10.289,10.289,0,0,1,4.569,1.01,9.212,9.212,0,0,1,3.457,2.915v-3.442h2.691v21.58h-2.691v-3.423Zm20.365,3.423h-12.858V321.3h2.813v25.8h10.045v2.774Zm6.075-24.111h-2.772V321.3h2.772v4.461Zm-2.772,24.111v-21.58h2.772v21.58Zm10.935,1.769a5.416,5.416,0,0,0,2.276,2.923,7.273,7.273,0,0,0,4.008,1.054,7.584,7.584,0,0,0,5.915-2.46,9.371,9.371,0,0,0,2.227-6.557v-.569a10.918,10.918,0,0,1-3.569,3.231,9.063,9.063,0,0,1-4.415,1.09A11.433,11.433,0,0,1,2414.265,331a11.413,11.413,0,0,1,12.584-2.258,9.715,9.715,0,0,1,3.52,3.069v-3.524h2.694v17.995q0,5.656-2.835,8.841a9.915,9.915,0,0,1-7.815,3.182,10.771,10.771,0,0,1-6.295-1.818,8.155,8.155,0,0,1-3.39-4.852Zm-1.929-12.747a8.888,8.888,0,0,0,2.407,6.336,7.7,7.7,0,0,0,11.458-.007,8.42,8.42,0,0,0,2.451-6.015,8.918,8.918,0,0,0-2.418-6.295,7.5,7.5,0,0,0-5.692-2.613,7.79,7.79,0,0,0-5.788,2.484,8.4,8.4,0,0,0-2.418,6.109Zm23.309-17.594h2.73v9.516a7.728,7.728,0,0,1,2.875-2.224,9.216,9.216,0,0,1,3.763-.745q4.549,0,6.631,2.6t2.08,8.451v10.973h-2.73V338.855q0-4.69-1.413-6.522t-4.729-1.833a6.94,6.94,0,0,0-3.307.755,5.586,5.586,0,0,0-2.245,2.17,6.033,6.033,0,0,0-.715,2.008,24.547,24.547,0,0,0-.21,3.932v10.5h-2.73V321.3Zm32.073,21.779h2.853v.08a4.912,4.912,0,0,0,1.158,3.343,3.656,3.656,0,0,0,2.861,1.318,3.785,3.785,0,0,0,2.7-1.017,3.4,3.4,0,0,0,1.076-2.571,3.566,3.566,0,0,0-.858-2.491,7.954,7.954,0,0,0-3.086-1.762q-3.585-1.276-4.68-2.613a5.454,5.454,0,0,1-1.1-3.567,5.736,5.736,0,0,1,1.835-4.3,6.159,6.159,0,0,1,4.438-1.767,6.068,6.068,0,0,1,4.394,1.566,6.206,6.206,0,0,1,1.747,4.382h-2.974a3.469,3.469,0,0,0-.969-2.371,3.287,3.287,0,0,0-2.387-.842,3.019,3.019,0,0,0-2.25.91,3.1,3.1,0,0,0-.9,2.262,3.235,3.235,0,0,0,.374,1.623,3.336,3.336,0,0,0,1.231,1.182,9.768,9.768,0,0,0,2.292.946c1,.3,1.675.523,2.016.663a6.546,6.546,0,0,1,2.982,2.295,6.481,6.481,0,0,1,.949,3.652,6.074,6.074,0,0,1-1.943,4.614,6.945,6.945,0,0,1-4.93,1.821,6.354,6.354,0,0,1-4.889-1.989,7.931,7.931,0,0,1-1.941-5.364ZM2363.659,317.6a8.964,8.964,0,0,0-6.334-2.689l-.014,1.656a7.326,7.326,0,0,1,7.259,7.4l1.658.017a8.978,8.978,0,0,0-2.569-6.387Zm-2.641,2.59a5.276,5.276,0,0,1,1.516,3.762l-1.658-.017a3.631,3.631,0,0,0-3.6-3.67l.016-1.66a5.267,5.267,0,0,1,3.729,1.585Zm-4.8,2.666a1.461,1.461,0,1,1-.019,2.067,1.462,1.462,0,0,1,.019-2.067Zm105.144,27.107V322.3a12.142,12.142,0,0,1,2.774,2.246V349.96Zm0-30.2V316.09h2.774V321.5a14.6,14.6,0,0,0-2.774-1.731Zm-11.815-.052-.083.292a.772.772,0,0,0,.526.943l4.124,1.186a.788.788,0,0,0,.578-.068.8.8,0,0,0,.364-.46l.509-1.772a17.331,17.331,0,0,1,4.063,1.007,12.972,12.972,0,0,1,6.05,4.725.56.56,0,0,0,.917-.644,14.11,14.11,0,0,0-6.562-5.125,23.1,23.1,0,0,0-10.32-1.161.559.559,0,0,0-.165,1.078Zm4.323,2.752-4.173-1.2a2.4,2.4,0,0,0,4.173,1.2Zm-4.8.431-1.248,1.219a.279.279,0,0,0,.387.4l1.255-1.219a.283.283,0,0,0,.005-.4.288.288,0,0,0-.4-.005Zm3.391,1.486-.173,1.875a.281.281,0,0,0,.255.3.278.278,0,0,0,.3-.252l.177-1.873a.282.282,0,0,0-.561-.052Zm-1.776-.571L2449.4,327.1a.281.281,0,0,0,.516.222l1.283-3.3a.28.28,0,0,0-.146-.368A.284.284,0,0,0,2450.68,323.81Z",
    transform: "translate(-2330.455 -314.908)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16258",
    "data-name": "Group 16258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16257",
    "data-name": "Group 16257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    "data-name": "Path 21051",
    d: "M2341.037,356.571,2328.4,311.207l151.618,8.4,12.637,45.365Z",
    transform: "translate(-2331.969 -317.632)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21052",
    "data-name": "Path 21052",
    d: "M2392.967,321.375c-.273-.014-.464.085-.426.222s.29.26.564.274.464-.083.427-.221S2393.239,321.39,2392.967,321.375Z",
    transform: "translate(-2284.765 -310.15)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21053",
    "data-name": "Path 21053",
    d: "M2393.133,321.528c.18.01.348.094.375.184s-.1.158-.285.148-.349-.092-.377-.184.1-.156.287-.147Zm-.071-.247c-.453-.024-.773.139-.71.368s.486.432.941.457.775-.139.711-.368S2393.516,321.305,2393.062,321.281Z",
    transform: "translate(-2284.908 -310.219)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21054",
    "data-name": "Path 21054",
    d: "M2393.225,321.436c.366.019.7.184.754.366s-.2.314-.568.3-.7-.187-.751-.368.2-.316.566-.293Zm-.069-.252c-.636-.033-1.078.2-.993.516s.681.609,1.317.644,1.084-.2.993-.514S2393.794,321.221,2393.156,321.184Z",
    transform: "translate(-2285.049 -310.291)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21055",
    "data-name": "Path 21055",
    d: "M2393.322,321.339c.545.031,1.05.278,1.126.552s-.3.47-.853.441-1.051-.279-1.127-.55.3-.474.853-.443Zm-.069-.248c-.821-.047-1.39.252-1.276.663s.872.781,1.689.825,1.39-.252,1.278-.661S2394.07,321.138,2393.253,321.091Z",
    transform: "translate(-2285.189 -310.361)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21056",
    "data-name": "Path 21056",
    d: "M2393.415,321.245c.731.04,1.4.37,1.507.734s-.409.628-1.135.588-1.4-.37-1.5-.734.406-.628,1.134-.588Zm-.068-.25c-1-.054-1.7.307-1.561.811s1.066.953,2.066,1.01,1.7-.309,1.562-.811S2394.349,321.053,2393.347,321Z",
    transform: "translate(-2285.332 -310.432)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21057",
    "data-name": "Path 21057",
    d: "M2393.513,321.151c.91.05,1.749.462,1.876.917s-.507.786-1.419.736-1.75-.46-1.877-.92.507-.785,1.42-.733Zm-.072-.25c-1.182-.064-2.008.363-1.843.957s1.26,1.128,2.443,1.193,2.01-.361,1.847-.953S2394.625,320.967,2393.441,320.9Z",
    transform: "translate(-2285.472 -310.502)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21058",
    "data-name": "Path 21058",
    d: "M2393.605,321.055c1.094.061,2.1.555,2.255,1.1s-.611.944-1.7.884-2.106-.555-2.258-1.1.611-.944,1.7-.884Zm-.069-.248c-1.366-.075-2.315.418-2.127,1.1s1.453,1.3,2.82,1.377,2.319-.418,2.127-1.1S2394.9,320.884,2393.536,320.806Z",
    transform: "translate(-2285.614 -310.573)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21059",
    "data-name": "Path 21059",
    d: "M2393.7,320.96c1.278.069,2.455.646,2.634,1.285s-.712,1.1-1.986,1.029-2.453-.644-2.632-1.285.714-1.1,1.984-1.029Zm-.068-.248c-1.548-.085-2.626.474-2.409,1.25s1.646,1.476,3.192,1.561,2.628-.474,2.411-1.25S2395.18,320.8,2393.631,320.712Z",
    transform: "translate(-2285.754 -310.643)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21060",
    "data-name": "Path 21060",
    d: "M2393.8,320.866c1.456.08,2.8.738,3.007,1.467s-.813,1.259-2.269,1.179-2.805-.738-3.008-1.47.812-1.257,2.271-1.175Zm-.069-.248c-1.731-.1-2.937.529-2.7,1.4s1.84,1.649,3.571,1.746,2.937-.531,2.7-1.4S2395.458,320.713,2393.728,320.617Z",
    transform: "translate(-2285.896 -310.714)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21061",
    "data-name": "Path 21061",
    d: "M2393.891,320.769c1.639.092,3.155.832,3.383,1.653s-.915,1.415-2.555,1.325-3.153-.832-3.382-1.653.913-1.415,2.554-1.324Zm-.07-.247c-1.913-.108-3.246.585-2.977,1.545s2.032,1.819,3.946,1.925,3.246-.585,2.975-1.542S2395.735,320.629,2393.822,320.523Z",
    transform: "translate(-2286.036 -310.784)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21062",
    "data-name": "Path 21062",
    d: "M2393.986,320.677c1.821.1,3.505.922,3.758,1.833s-1.015,1.573-2.834,1.474-3.5-.924-3.759-1.837,1.014-1.571,2.835-1.47Zm-.067-.25c-2.1-.116-3.556.641-3.264,1.691s2.229,2,4.323,2.113,3.555-.641,3.262-1.691S2396.014,320.542,2393.919,320.427Z",
    transform: "translate(-2286.178 -310.855)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21063",
    "data-name": "Path 21063",
    d: "M2394.081,320.581c2,.111,3.855,1.016,4.137,2.021s-1.118,1.727-3.123,1.618-3.852-1.016-4.135-2.022,1.12-1.727,3.122-1.616Zm-.068-.248c-2.276-.127-3.864.7-3.546,1.838s2.421,2.17,4.7,2.295,3.863-.7,3.547-1.837S2396.29,320.459,2394.012,320.333Z",
    transform: "translate(-2286.319 -310.925)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21064",
    "data-name": "Path 21064",
    d: "M2394.178,320.486c2.184.122,4.2,1.106,4.51,2.2s-1.221,1.889-3.408,1.767-4.2-1.108-4.507-2.2,1.217-1.885,3.4-1.764Zm-.069-.248c-2.46-.137-4.176.752-3.831,1.986s2.615,2.342,5.073,2.479,4.173-.753,3.83-1.986S2396.564,320.373,2394.109,320.238Z",
    transform: "translate(-2286.459 -310.996)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21065",
    "data-name": "Path 21065",
    d: "M2394.272,320.392c2.368.13,4.554,1.2,4.885,2.385s-1.322,2.047-3.687,1.913-4.555-1.2-4.885-2.387,1.319-2.043,3.687-1.911Zm-.069-.25c-2.642-.144-4.483.809-4.114,2.134s2.808,2.517,5.448,2.661,4.484-.807,4.113-2.13S2396.844,320.29,2394.2,320.142Z",
    transform: "translate(-2286.602 -311.066)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21066",
    "data-name": "Path 21066",
    d: "M2394.367,320.3c2.55.141,4.906,1.293,5.262,2.573s-1.422,2.2-3.972,2.059-4.907-1.293-5.262-2.573,1.42-2.2,3.972-2.059Zm-.068-.248c-2.822-.156-4.792.866-4.4,2.279s3,2.689,5.824,2.847,4.793-.865,4.4-2.279S2397.122,320.2,2394.3,320.048Z",
    transform: "translate(-2286.743 -311.137)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21067",
    "data-name": "Path 21067",
    d: "M2394.463,320.2c2.733.151,5.257,1.384,5.636,2.753s-1.522,2.359-4.255,2.206-5.255-1.384-5.638-2.753,1.524-2.359,4.256-2.206Zm-.069-.25c-3-.165-5.1.922-4.682,2.43s3.2,2.863,6.2,3.027,5.1-.92,4.681-2.425S2397.4,320.119,2394.394,319.952Z",
    transform: "translate(-2286.884 -311.208)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21068",
    "data-name": "Path 21068",
    d: "M2394.558,320.107c2.913.16,5.607,1.477,6.015,2.937s-1.627,2.514-4.54,2.354-5.607-1.477-6.014-2.937,1.625-2.517,4.538-2.354Zm-.07-.248c-3.187-.179-5.409.976-4.964,2.573s3.39,3.036,6.577,3.215,5.41-.977,4.965-2.574S2397.675,320.036,2394.488,319.859Z",
    transform: "translate(-2287.026 -311.278)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21069",
    "data-name": "Path 21069",
    d: "M2394.651,320.011c3.1.174,5.958,1.569,6.39,3.123s-1.727,2.672-4.822,2.5-5.956-1.569-6.388-3.123,1.726-2.67,4.821-2.5Zm-.068-.247c-3.369-.187-5.72,1.031-5.248,2.72s3.583,3.21,6.952,3.4,5.718-1.031,5.248-2.72S2397.953,319.95,2394.583,319.764Z",
    transform: "translate(-2287.166 -311.348)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21070",
    "data-name": "Path 21070",
    d: "M2394.749,319.918c3.278.181,6.305,1.66,6.763,3.305s-1.828,2.828-5.105,2.644-6.309-1.658-6.767-3.3,1.829-2.83,5.108-2.647Zm-.071-.248c-3.55-.2-6.027,1.087-5.531,2.868s3.775,3.383,7.327,3.579,6.029-1.087,5.531-2.868S2398.23,319.864,2394.678,319.67Z",
    transform: "translate(-2287.308 -311.419)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21071",
    "data-name": "Path 21071",
    d: "M2394.841,319.822c3.464.191,6.658,1.753,7.142,3.488s-1.931,2.989-5.392,2.8-6.654-1.755-7.138-3.491,1.928-2.986,5.388-2.793Zm-.067-.248c-3.733-.207-6.337,1.144-5.816,3.015s3.97,3.557,7.7,3.765,6.337-1.142,5.816-3.017S2398.508,319.78,2394.774,319.574Z",
    transform: "translate(-2287.448 -311.49)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21072",
    "data-name": "Path 21072",
    d: "M2394.938,319.727c3.644.2,7.008,1.845,7.515,3.673s-2.028,3.142-5.673,2.939-7.006-1.845-7.517-3.672,2.033-3.144,5.675-2.941Zm-.07-.248c-3.916-.215-6.645,1.2-6.1,3.161s4.166,3.732,8.082,3.949,6.645-1.2,6.1-3.163S2398.784,319.7,2394.868,319.479Z",
    transform: "translate(-2287.589 -311.56)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21073",
    "data-name": "Path 21073",
    d: "M2395.034,319.634c3.824.212,7.357,1.939,7.891,3.856s-2.132,3.3-5.956,3.088-7.358-1.937-7.895-3.856,2.133-3.3,5.959-3.088Zm-.07-.25c-4.1-.226-6.956,1.257-6.385,3.31s4.361,3.9,8.459,4.132,6.954-1.255,6.381-3.311S2399.062,319.613,2394.965,319.384Z",
    transform: "translate(-2287.731 -311.631)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21074",
    "data-name": "Path 21074",
    d: "M2395.128,319.537c4.008.222,7.711,2.033,8.27,4.04s-2.238,3.458-6.242,3.238-7.71-2.033-8.269-4.041,2.232-3.458,6.241-3.236Zm-.07-.246c-4.279-.24-7.267,1.311-6.666,3.454s4.552,4.078,8.831,4.316,7.265-1.312,6.668-3.456S2399.34,319.526,2395.059,319.29Z",
    transform: "translate(-2287.872 -311.701)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21075",
    "data-name": "Path 21075",
    d: "M2395.222,319.443c4.189.233,8.058,2.121,8.643,4.224s-2.334,3.614-6.523,3.382-8.059-2.121-8.644-4.224,2.335-3.613,6.524-3.382Zm-.068-.248c-4.461-.247-7.574,1.366-6.951,3.6s4.747,4.253,9.209,4.5,7.573-1.368,6.948-3.6S2399.616,319.441,2395.154,319.195Z",
    transform: "translate(-2288.012 -311.772)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21076",
    "data-name": "Path 21076",
    d: "M2395.321,319.348c4.37.24,8.406,2.215,9.017,4.408s-2.436,3.77-6.809,3.531-8.409-2.217-9.018-4.408,2.438-3.774,6.81-3.531Zm-.071-.248c-4.642-.257-7.883,1.422-7.236,3.751s4.938,4.423,9.584,4.682,7.883-1.422,7.236-3.751S2399.893,319.357,2395.25,319.1Z",
    transform: "translate(-2288.155 -311.842)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21077",
    "data-name": "Path 21077",
    d: "M2395.413,319.252c4.553.253,8.76,2.309,9.4,4.592s-2.539,3.93-7.095,3.677-8.758-2.309-9.392-4.592,2.538-3.928,7.09-3.677Zm-.069-.246c-4.826-.267-8.193,1.477-7.517,3.9s5.133,4.6,9.957,4.866,8.2-1.479,7.521-3.9S2400.171,319.271,2395.344,319.006Z",
    transform: "translate(-2288.296 -311.912)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21078",
    "data-name": "Path 21078",
    d: "M2395.509,319.16c4.736.262,9.111,2.4,9.772,4.774s-2.64,4.085-7.376,3.823-9.108-2.4-9.771-4.772,2.64-4.088,7.376-3.824Zm-.068-.25c-5.01-.276-8.5,1.535-7.8,4.043s5.328,4.774,10.336,5.053,8.5-1.536,7.8-4.046S2400.448,319.188,2395.441,318.91Z",
    transform: "translate(-2288.437 -311.983)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21079",
    "data-name": "Path 21079",
    d: "M2395.6,319.064c4.916.272,9.463,2.493,10.146,4.958s-2.741,4.243-7.657,3.972-9.461-2.493-10.148-4.958,2.741-4.244,7.659-3.972Zm-.067-.248c-5.193-.288-8.812,1.588-8.087,4.192s5.522,4.946,10.71,5.232,8.812-1.59,8.086-4.191S2400.726,319.1,2395.536,318.815Z",
    transform: "translate(-2288.578 -312.054)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21080",
    "data-name": "Path 21080",
    d: "M2395.7,318.969c5.1.281,9.812,2.583,10.522,5.142s-2.842,4.4-7.942,4.116-9.811-2.583-10.523-5.14,2.844-4.4,7.944-4.118Zm-.071-.248c-5.373-.3-9.119,1.644-8.368,4.338s5.715,5.119,11.087,5.418,9.121-1.646,8.368-4.34S2401,319.019,2395.628,318.721Z",
    transform: "translate(-2288.719 -312.124)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21081",
    "data-name": "Path 21081",
    d: "M2395.793,318.873c5.281.293,10.162,2.677,10.9,5.326s-2.946,4.557-8.229,4.265-10.161-2.677-10.9-5.326,2.946-4.555,8.227-4.265Zm-.07-.248c-5.553-.306-9.427,1.7-8.652,4.486s5.907,5.293,11.462,5.6,9.428-1.7,8.652-4.484S2401.281,318.934,2395.723,318.625Z",
    transform: "translate(-2288.86 -312.195)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21082",
    "data-name": "Path 21082",
    d: "M2395.888,318.778c5.464.3,10.514,2.769,11.276,5.51s-3.048,4.715-8.511,4.411-10.512-2.769-11.274-5.506,3.045-4.717,8.508-4.415Zm-.071-.246c-5.734-.319-9.734,1.755-8.933,4.632s6.1,5.467,11.839,5.786,9.737-1.757,8.935-4.635S2401.557,318.849,2395.817,318.532Z",
    transform: "translate(-2289.001 -312.265)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21083",
    "data-name": "Path 21083",
    d: "M2395.983,318.686c5.645.311,10.862,2.859,11.651,5.69s-3.149,4.873-8.794,4.559-10.862-2.861-11.65-5.692,3.147-4.871,8.793-4.557Zm-.068-.25c-5.922-.328-10.048,1.812-9.22,4.781s6.293,5.638,12.211,5.967,10.048-1.811,9.223-4.779S2401.833,318.764,2395.916,318.436Z",
    transform: "translate(-2289.142 -312.336)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21084",
    "data-name": "Path 21084",
    d: "M2396.08,318.59c5.828.323,11.213,2.953,12.025,5.876s-3.25,5.031-9.079,4.706-11.211-2.955-12.025-5.876,3.249-5.029,9.079-4.706Zm-.069-.248c-6.1-.339-10.359,1.868-9.5,4.925s6.487,5.815,12.589,6.154,10.357-1.868,9.5-4.928S2402.11,318.678,2396.01,318.342Z",
    transform: "translate(-2289.283 -312.406)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21085",
    "data-name": "Path 21085",
    d: "M2396.174,318.5c6.007.333,11.561,3.045,12.4,6.059s-3.351,5.187-9.362,4.854-11.561-3.047-12.4-6.06,3.352-5.185,9.363-4.852Zm-.072-.25c-6.28-.347-10.661,1.925-9.786,5.076s6.682,5.987,12.966,6.334,10.666-1.923,9.787-5.074S2402.387,318.6,2396.1,318.246Z",
    transform: "translate(-2289.425 -312.477)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21086",
    "data-name": "Path 21086",
    d: "M2396.269,318.4c6.2.344,11.914,3.137,12.779,6.244s-3.453,5.343-9.645,5-11.914-3.137-12.779-6.243,3.453-5.345,9.645-5Zm-.067-.248c-6.465-.359-10.974,1.981-10.074,5.222s6.879,6.159,13.346,6.52,10.971-1.981,10.068-5.224S2402.668,318.511,2396.2,318.151Z",
    transform: "translate(-2289.567 -312.548)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21087",
    "data-name": "Path 21087",
    d: "M2396.365,318.305c6.375.354,12.261,3.232,13.153,6.427s-3.553,5.5-9.928,5.149-12.263-3.232-13.157-6.428,3.557-5.5,9.932-5.147Zm-.069-.248c-6.65-.37-11.282,2.036-10.356,5.369s7.071,6.333,13.718,6.7,11.283-2.034,10.357-5.366S2402.942,318.425,2396.3,318.057Z",
    transform: "translate(-2289.707 -312.618)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21088",
    "data-name": "Path 21088",
    d: "M2396.458,318.21c6.557.363,12.615,3.321,13.531,6.611s-3.656,5.659-10.213,5.293-12.614-3.323-13.528-6.609,3.654-5.658,10.211-5.295Zm-.069-.248c-6.827-.378-11.589,2.092-10.636,5.515s7.263,6.506,14.093,6.885,11.593-2.088,10.638-5.515S2403.22,318.339,2396.389,317.962Z",
    transform: "translate(-2289.848 -312.688)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21089",
    "data-name": "Path 21089",
    d: "M2396.555,318.115c6.74.375,12.964,3.415,13.9,6.795s-3.755,5.817-10.5,5.442-12.962-3.414-13.9-6.794,3.757-5.814,10.5-5.442Zm-.069-.248c-7.01-.387-11.9,2.149-10.923,5.664s7.459,6.68,14.471,7.067,11.9-2.144,10.922-5.661S2403.5,318.255,2396.486,317.867Z",
    transform: "translate(-2289.99 -312.759)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21090",
    "data-name": "Path 21090",
    d: "M2396.649,318.02c6.922.385,13.313,3.508,14.281,6.979s-3.86,5.973-10.778,5.59-13.316-3.51-14.283-6.98,3.86-5.972,10.78-5.588Zm-.068-.247c-7.2-.4-12.211,2.2-11.205,5.809s7.653,6.853,14.844,7.251,12.213-2.2,11.206-5.807S2403.775,318.171,2396.581,317.773Z",
    transform: "translate(-2290.131 -312.829)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21091",
    "data-name": "Path 21091",
    d: "M2396.746,317.928c7.1.392,13.664,3.6,14.657,7.159s-3.959,6.13-11.063,5.736-13.666-3.6-14.658-7.161,3.961-6.13,11.065-5.734Zm-.069-.252c-7.376-.408-12.52,2.262-11.491,5.96s7.848,7.025,15.223,7.435,12.52-2.257,11.489-5.956S2404.052,318.086,2396.676,317.677Z",
    transform: "translate(-2290.272 -312.901)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21092",
    "data-name": "Path 21092",
    d: "M2396.839,317.831c7.284.4,14.016,3.692,15.034,7.345s-4.063,6.286-11.347,5.883-14.018-3.692-15.033-7.345,4.06-6.288,11.346-5.883Zm-.068-.248c-7.56-.42-12.83,2.314-11.773,6.1s8.039,7.2,15.6,7.623,12.831-2.314,11.775-6.1S2404.328,318,2396.771,317.583Z",
    transform: "translate(-2290.413 -312.971)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21093",
    "data-name": "Path 21093",
    d: "M2396.936,317.737c7.466.411,14.366,3.784,15.41,7.529s-4.168,6.444-11.631,6.029-14.367-3.784-15.411-7.529,4.163-6.444,11.631-6.029Zm-.069-.25c-7.741-.429-13.14,2.371-12.057,6.253s8.234,7.374,15.971,7.8,13.139-2.37,12.058-6.251S2404.605,317.918,2396.866,317.487Z",
    transform: "translate(-2290.554 -313.042)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21094",
    "data-name": "Path 21094",
    d: "M2397.03,317.643c7.65.422,14.718,3.876,15.785,7.711s-4.265,6.6-11.914,6.178-14.717-3.878-15.785-7.713,4.265-6.6,11.914-6.176Zm-.068-.25c-7.925-.437-13.447,2.427-12.342,6.4s8.428,7.548,16.351,7.989,13.445-2.427,12.337-6.4S2404.883,317.832,2396.962,317.393Z",
    transform: "translate(-2290.696 -313.112)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21095",
    "data-name": "Path 21095",
    d: "M2397.126,317.546c7.829.434,15.066,3.968,16.159,7.9s-4.367,6.758-12.2,6.326-15.066-3.97-16.16-7.9,4.366-6.758,12.2-6.324Zm-.069-.248c-8.108-.448-13.758,2.482-12.624,6.545s8.619,7.723,16.724,8.171,13.755-2.481,12.624-6.545S2405.161,317.748,2397.057,317.3Z",
    transform: "translate(-2290.836 -313.182)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21096",
    "data-name": "Path 21096",
    d: "M2397.22,317.452c8.014.444,15.419,4.06,16.536,8.081s-4.468,6.913-12.481,6.468-15.418-4.06-16.538-8.079,4.47-6.914,12.484-6.47Zm-.068-.248c-8.288-.46-14.067,2.538-12.908,6.694s8.815,7.893,17.1,8.352,14.064-2.536,12.907-6.69S2405.436,317.662,2397.152,317.2Z",
    transform: "translate(-2290.978 -313.253)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21097",
    "data-name": "Path 21097",
    d: "M2397.316,317.36c8.194.451,15.764,4.151,16.914,8.26s-4.573,7.074-12.768,6.619-15.768-4.152-16.912-8.263,4.569-7.074,12.766-6.616Zm-.069-.252c-8.469-.469-14.376,2.593-13.194,6.841s9.009,8.069,17.478,8.537,14.374-2.593,13.191-6.84S2405.715,317.579,2397.248,317.108Z",
    transform: "translate(-2291.12 -313.324)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21098",
    "data-name": "Path 21098",
    d: "M2397.411,317.261c8.377.465,16.118,4.246,17.287,8.447s-4.67,7.23-13.049,6.765-16.117-4.246-17.287-8.445,4.672-7.23,13.05-6.767Zm-.068-.247c-8.652-.479-14.684,2.646-13.476,6.986s9.2,8.242,17.851,8.721,14.684-2.649,13.478-6.985S2405.993,317.494,2397.343,317.015Z",
    transform: "translate(-2291.26 -313.393)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21099",
    "data-name": "Path 21099",
    d: "M2397.5,317.167c8.56.474,16.468,4.336,17.665,8.631s-4.774,7.386-13.334,6.911-16.467-4.338-17.663-8.629,4.774-7.388,13.332-6.913Zm-.067-.248c-8.832-.49-14.994,2.7-13.759,7.133s9.395,8.416,18.229,8.905,14.991-2.7,13.755-7.133S2406.268,317.409,2397.437,316.919Z",
    transform: "translate(-2291.401 -313.464)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21100",
    "data-name": "Path 21100",
    d: "M2397.6,317.073c8.744.484,16.82,4.43,18.04,8.813s-4.872,7.544-13.615,7.06-16.818-4.432-18.042-8.815,4.876-7.544,13.617-7.058Zm-.068-.248c-9.015-.5-15.3,2.76-14.042,7.282s9.59,8.588,18.6,9.088,15.3-2.76,14.044-7.282S2406.546,317.324,2397.531,316.824Z",
    transform: "translate(-2291.543 -313.535)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21101",
    "data-name": "Path 21101",
    d: "M2397.7,316.979c8.926.493,17.17,4.522,18.417,9s-4.975,7.7-13.9,7.208-17.17-4.524-18.418-9,4.979-7.7,13.9-7.206Zm-.066-.25c-9.2-.509-15.613,2.816-14.328,7.428s9.782,8.763,18.981,9.275,15.61-2.819,14.325-7.43S2406.823,317.239,2397.629,316.729Z",
    transform: "translate(-2291.684 -313.606)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21102",
    "data-name": "Path 21102",
    d: "M2397.792,316.882c9.1.505,17.519,4.614,18.793,9.183s-5.081,7.859-14.186,7.352-17.517-4.614-18.793-9.181,5.08-7.857,14.187-7.354Zm-.07-.247c-9.378-.521-15.919,2.87-14.611,7.572s9.976,8.938,19.355,9.458,15.921-2.871,14.612-7.574S2407.1,317.154,2397.722,316.635Z",
    transform: "translate(-2291.825 -313.676)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21103",
    "data-name": "Path 21103",
    d: "M2397.885,316.787c9.289.516,17.872,4.708,19.167,9.365s-5.177,8.015-14.465,7.5-17.872-4.708-19.167-9.366,5.179-8.017,14.466-7.5Zm-.068-.247c-9.561-.531-16.231,2.925-14.894,7.721s10.171,9.107,19.731,9.638,16.229-2.927,14.894-7.723S2407.378,317.07,2397.817,316.541Z",
    transform: "translate(-2291.966 -313.746)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21104",
    "data-name": "Path 21104",
    d: "M2397.98,316.693c9.473.524,18.222,4.8,19.545,9.549s-5.281,8.171-14.753,7.645-18.219-4.8-19.542-9.548,5.281-8.173,14.75-7.647Zm-.068-.248c-9.742-.54-16.537,2.982-15.177,7.867s10.366,9.286,20.108,9.826,16.538-2.982,15.177-7.869S2407.654,316.985,2397.912,316.445Z",
    transform: "translate(-2292.108 -313.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21105",
    "data-name": "Path 21105",
    d: "M2398.075,316.6c9.652.536,18.571,4.892,19.92,9.734s-5.383,8.329-15.037,7.8-18.57-4.894-19.918-9.734,5.382-8.331,15.034-7.8Zm-.068-.247c-9.926-.552-16.847,3.038-15.46,8.015s10.555,9.457,20.481,10.008,16.848-3.038,15.463-8.015S2407.93,316.9,2398.007,316.351Z",
    transform: "translate(-2292.248 -313.887)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21106",
    "data-name": "Path 21106",
    d: "M2398.172,316.5c9.834.545,18.92,4.986,20.295,9.918s-5.485,8.485-15.319,7.94-18.923-4.986-20.294-9.916,5.483-8.487,15.319-7.942Zm-.071-.247c-10.106-.562-17.155,3.094-15.744,8.161s10.751,9.633,20.858,10.193,17.158-3.1,15.747-8.166S2408.209,316.815,2398.1,316.256Z",
    transform: "translate(-2292.389 -313.958)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21107",
    "data-name": "Path 21107",
    d: "M2398.266,316.409c10.018.556,19.273,5.076,20.67,10.1s-5.584,8.643-15.6,8.09-19.273-5.078-20.67-10.1,5.584-8.642,15.6-8.088Zm-.069-.248c-10.288-.569-17.464,3.149-16.026,8.31s10.945,9.8,21.232,10.376,17.467-3.151,16.03-8.31S2408.486,316.732,2398.2,316.16Z",
    transform: "translate(-2292.531 -314.029)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21108",
    "data-name": "Path 21108",
    d: "M2398.361,316.314c10.2.566,19.62,5.168,21.045,10.284s-5.687,8.8-15.885,8.235-19.624-5.17-21.045-10.282,5.685-8.8,15.886-8.237Zm-.071-.248c-10.469-.58-17.773,3.2-16.309,8.456s11.138,9.978,21.609,10.56,17.774-3.206,16.311-8.458S2408.763,316.646,2398.29,316.066Z",
    transform: "translate(-2292.671 -314.099)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21109",
    "data-name": "Path 21109",
    d: "M2398.457,316.218c10.383.576,19.972,5.262,21.421,10.468s-5.789,8.959-16.168,8.383-19.972-5.262-21.423-10.466,5.789-8.959,16.17-8.385Zm-.07-.248c-10.653-.589-18.083,3.264-16.6,8.605s11.333,10.152,21.988,10.742,18.082-3.262,16.594-8.6S2409.042,316.562,2398.387,315.97Z",
    transform: "translate(-2292.814 -314.17)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21110",
    "data-name": "Path 21110",
    d: "M2398.553,316.124c10.564.587,20.321,5.354,21.8,10.652s-5.892,9.114-16.455,8.529-20.321-5.354-21.8-10.65,5.892-9.116,16.455-8.531Zm-.069-.248c-10.838-.6-18.395,3.317-16.881,8.751s11.527,10.325,22.363,10.928,18.393-3.319,16.88-8.753S2409.321,316.478,2398.484,315.876Z",
    transform: "translate(-2292.954 -314.24)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21111",
    "data-name": "Path 21111",
    d: "M2398.647,316.028c10.745.6,20.673,5.447,22.175,10.836s-6,9.272-16.738,8.676-20.673-5.446-22.173-10.834,5.993-9.272,16.737-8.678Zm-.07-.246c-11.02-.611-18.7,3.373-17.163,8.9s11.721,10.5,22.738,11.11,18.7-3.375,17.163-8.9S2409.6,316.392,2398.577,315.781Z",
    transform: "translate(-2293.096 -314.311)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21112",
    "data-name": "Path 21112",
    d: "M2398.743,315.935c10.926.606,21.022,5.538,22.548,11.016s-6.093,9.43-17.021,8.824-21.023-5.538-22.549-11.016,6.094-9.43,17.021-8.824Zm-.07-.248c-11.2-.62-19.012,3.429-17.446,9.044s11.911,10.673,23.113,11.294,19.01-3.429,17.446-9.046S2409.872,316.308,2398.673,315.687Z",
    transform: "translate(-2293.237 -314.381)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21113",
    "data-name": "Path 21113",
    d: "M2398.837,315.84c11.108.615,21.373,5.63,22.925,11.2s-6.194,9.588-17.3,8.971-21.375-5.63-22.927-11.2,6.2-9.586,17.305-8.97Zm-.07-.248c-11.383-.63-19.319,3.486-17.73,9.192s12.105,10.845,23.488,11.477,19.321-3.484,17.733-9.194S2410.15,316.222,2398.767,315.592Z",
    transform: "translate(-2293.377 -314.452)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21114",
    "data-name": "Path 21114",
    d: "M2398.931,315.745c11.295.627,21.726,5.723,23.3,11.386s-6.3,9.744-17.589,9.117-21.725-5.723-23.3-11.383,6.294-9.747,17.585-9.121Zm-.066-.248c-11.566-.639-19.63,3.543-18.016,9.339s12.3,11.02,23.866,11.662,19.628-3.543,18.012-9.339S2410.428,316.137,2398.865,315.5Z",
    transform: "translate(-2293.519 -314.522)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21115",
    "data-name": "Path 21115",
    d: "M2399.028,315.65c11.473.635,22.074,5.814,23.678,11.567s-6.4,9.9-17.873,9.268-22.074-5.815-23.679-11.568,6.4-9.9,17.874-9.267Zm-.068-.248c-11.747-.651-19.939,3.6-18.3,9.487s12.495,11.192,24.24,11.844,19.941-3.6,18.3-9.489S2410.705,316.055,2398.96,315.4Z",
    transform: "translate(-2293.661 -314.593)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21116",
    "data-name": "Path 21116",
    d: "M2399.124,315.556c11.654.646,22.424,5.907,24.054,11.752s-6.5,10.058-18.158,9.412-22.425-5.909-24.052-11.754,6.5-10.056,18.156-9.411Zm-.071-.248c-11.927-.661-20.244,3.652-18.581,9.633s12.688,11.367,24.619,12.027,20.247-3.651,18.58-9.633S2410.982,315.969,2399.052,315.307Z",
    transform: "translate(-2293.802 -314.663)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21117",
    "data-name": "Path 21117",
    d: "M2399.218,315.461c11.837.654,22.774,6,24.43,11.935s-6.6,10.216-18.441,9.56-22.776-6-24.428-11.936,6.6-10.214,18.439-9.558Zm-.068-.248c-12.113-.672-20.557,3.708-18.866,9.78s12.881,11.539,24.993,12.211,20.556-3.708,18.864-9.78S2411.258,315.883,2399.15,315.213Z",
    transform: "translate(-2293.943 -314.734)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21118",
    "data-name": "Path 21118",
    d: "M2399.312,315.365c12.021.667,23.123,6.091,24.8,12.119s-6.7,10.372-18.724,9.707-23.126-6.091-24.8-12.119,6.7-10.374,18.722-9.707Zm-.068-.248c-12.292-.68-20.868,3.764-19.149,9.928s13.076,11.712,25.37,12.395,20.864-3.764,19.15-9.928S2411.536,315.8,2399.244,315.117Z",
    transform: "translate(-2294.084 -314.805)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21119",
    "data-name": "Path 21119",
    d: "M2399.408,315.271c12.2.677,23.476,6.185,25.18,12.3s-6.8,10.529-19.007,9.853-23.473-6.185-25.181-12.3,6.806-10.53,19.008-9.853Zm-.069-.248c-12.475-.693-21.174,3.819-19.433,10.074s13.268,11.89,25.742,12.58,21.177-3.821,19.432-10.075S2411.813,315.715,2399.339,315.023Z",
    transform: "translate(-2294.225 -314.875)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21120",
    "data-name": "Path 21120",
    d: "M2399.5,315.176c12.383.684,23.828,6.276,25.556,12.487s-6.906,10.688-19.29,10-23.825-6.276-25.558-12.487,6.907-10.687,19.292-10Zm-.068-.248c-12.659-.7-21.484,3.875-19.719,10.221s13.462,12.06,26.121,12.763,21.486-3.876,19.717-10.221S2412.091,315.63,2399.435,314.928Z",
    transform: "translate(-2294.366 -314.946)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21121",
    "data-name": "Path 21121",
    d: "M2399.6,315.082c12.567.7,24.176,6.367,25.932,12.669s-7.01,10.846-19.574,10.148-24.177-6.369-25.932-12.671,7.008-10.845,19.574-10.147Zm-.071-.25c-12.839-.71-21.792,3.93-20,10.371s13.655,12.233,26.494,12.945,21.794-3.932,20-10.369S2412.37,315.544,2399.527,314.832Z",
    transform: "translate(-2294.507 -315.016)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21122",
    "data-name": "Path 21122",
    d: "M2399.693,314.986c12.749.707,24.527,6.461,26.307,12.855s-7.109,11-19.856,10.294-24.528-6.459-26.308-12.855,7.109-11,19.858-10.294Zm-.069-.248c-13.019-.72-22.1,3.986-20.283,10.515s13.85,12.409,26.873,13.131,22.1-3.986,20.283-10.516S2412.645,315.46,2399.624,314.738Z",
    transform: "translate(-2294.649 -315.087)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21123",
    "data-name": "Path 21123",
    d: "M2399.787,314.892c12.931.717,24.878,6.553,26.685,13.037s-7.213,11.159-20.142,10.444-24.877-6.555-26.684-13.039,7.211-11.159,20.141-10.442Zm-.068-.248c-13.2-.733-22.413,4.041-20.568,10.664s14.042,12.58,27.249,13.313,22.411-4.043,20.565-10.664S2412.924,315.374,2399.72,314.643Z",
    transform: "translate(-2294.789 -315.157)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21124",
    "data-name": "Path 21124",
    d: "M2399.883,314.8c13.112.727,25.227,6.647,27.06,13.221s-7.312,11.315-20.423,10.589-25.229-6.647-27.062-13.221,7.312-11.317,20.425-10.589Zm-.069-.248c-13.386-.743-22.722,4.1-20.851,10.81s14.237,12.754,27.622,13.5,22.72-4.1,20.851-10.812S2413.2,315.29,2399.814,314.549Z",
    transform: "translate(-2294.931 -315.228)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21125",
    "data-name": "Path 21125",
    d: "M2399.979,314.7c13.3.736,25.579,6.737,27.435,13.4s-7.413,11.473-20.708,10.737-25.577-6.739-27.435-13.405,7.414-11.473,20.708-10.735Zm-.068-.25c-13.566-.752-23.031,4.154-21.137,10.957s14.433,12.928,28,13.681,23.031-4.154,21.135-10.956S2413.478,315.207,2399.91,314.453Z",
    transform: "translate(-2295.072 -315.299)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21126",
    "data-name": "Path 21126",
    d: "M2400.073,314.609c13.478.747,25.928,6.829,27.812,13.587s-7.517,11.631-20.993,10.884-25.93-6.831-27.812-13.591,7.515-11.631,20.993-10.881Zm-.071-.25c-13.749-.76-23.338,4.21-21.415,11.1s14.624,13.1,28.373,13.862,23.34-4.208,21.42-11.1S2413.754,315.121,2400,314.359Z",
    transform: "translate(-2295.213 -315.369)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21127",
    "data-name": "Path 21127",
    d: "M2400.168,314.512c13.658.757,26.279,6.923,28.187,13.771s-7.618,11.789-21.276,11.032-26.279-6.925-28.188-13.773,7.62-11.787,21.278-11.03Zm-.07-.248c-13.929-.771-23.647,4.265-21.7,11.253s14.82,13.275,28.751,14.047,23.649-4.265,21.7-11.252S2414.033,315.037,2400.1,314.264Z",
    transform: "translate(-2295.354 -315.439)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21128",
    "data-name": "Path 21128",
    d: "M2400.264,314.418c13.841.766,26.628,7.015,28.564,13.955s-7.72,11.945-21.561,11.176-26.629-7.015-28.565-13.954,7.719-11.947,21.562-11.178Zm-.067-.248c-14.115-.783-23.96,4.321-21.988,11.4s15.012,13.452,29.128,14.233,23.958-4.321,21.984-11.4S2414.311,314.953,2400.2,314.17Z",
    transform: "translate(-2295.495 -315.51)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21129",
    "data-name": "Path 21129",
    d: "M2400.359,314.324c14.023.778,26.98,7.107,28.938,14.138s-7.82,12.1-21.843,11.327-26.979-7.11-28.938-14.139,7.822-12.1,21.844-11.325Zm-.07-.25c-14.3-.792-24.267,4.376-22.269,11.546s15.207,13.626,29.5,14.415,24.265-4.378,22.267-11.544S2414.586,314.867,2400.289,314.074Z",
    transform: "translate(-2295.636 -315.581)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21130",
    "data-name": "Path 21130",
    d: "M2400.454,314.228c14.206.788,27.331,7.2,29.313,14.323s-7.921,12.259-22.126,11.471-27.331-7.2-29.315-14.322,7.923-12.259,22.128-11.473Zm-.069-.248c-14.48-.8-24.576,4.432-22.554,11.693s15.4,13.794,29.878,14.6,24.578-4.432,22.554-11.693S2414.863,314.781,2400.386,313.979Z",
    transform: "translate(-2295.778 -315.651)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21131",
    "data-name": "Path 21131",
    d: "M2400.548,314.134c14.387.8,27.68,7.291,29.692,14.506s-8.023,12.417-22.413,11.62-27.678-7.293-29.69-14.507,8.024-12.416,22.412-11.619Zm-.069-.25c-14.661-.811-24.885,4.489-22.835,11.841s15.594,13.971,30.252,14.782,24.885-4.487,22.836-11.837S2415.141,314.7,2400.479,313.884Z",
    transform: "translate(-2295.919 -315.722)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21132",
    "data-name": "Path 21132",
    d: "M2400.644,314.037c14.568.809,28.029,7.387,30.065,14.691s-8.125,12.574-22.7,11.766-28.029-7.385-30.065-14.69,8.126-12.575,22.7-11.768Zm-.069-.246c-14.842-.825-25.194,4.543-23.121,11.985s15.789,14.145,30.631,14.967,25.193-4.545,23.118-11.987S2415.417,314.613,2400.575,313.79Z",
    transform: "translate(-2296.06 -315.792)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21133",
    "data-name": "Path 21133",
    d: "M2400.739,313.944c14.752.816,28.382,7.475,30.443,14.872s-8.226,12.732-22.978,11.914-28.383-7.479-30.444-14.874,8.229-12.732,22.979-11.912Zm-.068-.248c-15.026-.833-25.5,4.6-23.4,12.133s15.981,14.316,31,15.15,25.505-4.6,23.4-12.134S2415.7,314.529,2400.67,313.7Z",
    transform: "translate(-2296.201 -315.862)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21134",
    "data-name": "Path 21134",
    d: "M2400.835,313.848c14.933.828,28.73,7.569,30.816,15.058s-8.327,12.889-23.261,12.06-28.73-7.569-30.818-15.056,8.329-12.889,23.263-12.061Zm-.072-.248c-15.205-.844-25.812,4.656-23.687,12.28s16.176,14.49,31.381,15.334,25.814-4.656,23.689-12.28S2415.974,314.444,2400.764,313.6Z",
    transform: "translate(-2296.343 -315.933)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21135",
    "data-name": "Path 21135",
    d: "M2400.929,313.754c15.115.838,29.082,7.663,31.194,15.242s-8.43,13.044-23.547,12.207-29.081-7.663-31.191-15.242,8.428-13.044,23.544-12.207Zm-.069-.248c-15.388-.852-26.121,4.711-23.972,12.429s16.369,14.662,31.759,15.514,26.121-4.711,23.97-12.426S2416.25,314.358,2400.86,313.506Z",
    transform: "translate(-2296.484 -316.004)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21136",
    "data-name": "Path 21136",
    d: "M2401.023,313.659c15.3.847,29.434,7.753,31.571,15.424s-8.531,13.2-23.83,12.353-29.431-7.751-31.57-15.422,8.532-13.2,23.829-12.355Zm-.067-.248c-15.57-.864-26.431,4.767-24.255,12.575s16.562,14.837,32.131,15.7,26.432-4.767,24.258-12.575S2416.525,314.274,2400.956,313.411Z",
    transform: "translate(-2296.625 -316.074)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21137",
    "data-name": "Path 21137",
    d: "M2401.12,313.565c15.478.858,29.782,7.846,31.945,15.606s-8.633,13.36-24.112,12.5-29.784-7.846-31.945-15.61,8.633-13.36,24.113-12.5Zm-.069-.248c-15.752-.875-26.742,4.821-24.538,12.721s16.753,15.011,32.507,15.884,26.741-4.824,24.538-12.721S2416.8,314.19,2401.05,313.317Z",
    transform: "translate(-2296.766 -316.145)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21138",
    "data-name": "Path 21138",
    d: "M2401.216,313.469c15.66.87,30.131,7.939,32.32,15.794s-8.734,13.516-24.4,12.646-30.133-7.937-32.322-15.79,8.736-13.518,24.4-12.65Zm-.07-.248c-15.937-.882-27.05,4.88-24.824,12.869s16.952,15.184,32.887,16.068,27.048-4.878,24.821-12.869S2417.081,314.1,2401.146,313.221Z",
    transform: "translate(-2296.908 -316.215)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21139",
    "data-name": "Path 21139",
    d: "M2401.311,313.375c15.843.878,30.48,8.031,32.7,15.974s-8.836,13.674-24.68,12.8-30.485-8.032-32.7-15.976,8.834-13.674,24.682-12.8Zm-.072-.248c-16.118-.894-27.357,4.935-25.1,13.016s17.141,15.358,33.259,16.252,27.357-4.935,25.1-13.016S2417.357,314.02,2401.24,313.126Z",
    transform: "translate(-2297.048 -316.286)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21140",
    "data-name": "Path 21140",
    d: "M2401.405,313.278c16.027.889,30.833,8.124,33.072,16.16s-8.938,13.83-24.965,12.943-30.833-8.124-33.074-16.158,8.939-13.83,24.966-12.945Zm-.071-.247c-16.3-.9-27.666,4.989-25.389,13.162s17.338,15.532,33.636,16.434,27.666-4.989,25.39-13.162S2417.635,313.934,2401.334,313.032Z",
    transform: "translate(-2297.189 -316.356)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21141",
    "data-name": "Path 21141",
    d: "M2401.5,313.184c16.209.9,31.186,8.216,33.448,16.342s-9.041,13.988-25.25,13.089-31.183-8.215-33.448-16.341,9.039-13.988,25.249-13.091Zm-.071-.247c-16.48-.913-27.975,5.045-25.672,13.311s17.531,15.7,34.013,16.617,27.975-5.046,25.673-13.308S2417.912,313.85,2401.429,312.937Z",
    transform: "translate(-2297.331 -316.426)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21142",
    "data-name": "Path 21142",
    d: "M2401.595,313.09c16.392.91,31.535,8.308,33.825,16.526s-9.14,14.145-25.532,13.237-31.532-8.3-33.825-16.526,9.141-14.145,25.533-13.237Zm-.068-.248c-16.663-.922-28.285,5.1-25.958,13.457s17.726,15.879,34.389,16.8,28.284-5.1,25.954-13.457S2418.19,313.767,2401.527,312.842Z",
    transform: "translate(-2297.472 -316.497)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21143",
    "data-name": "Path 21143",
    d: "M2401.69,312.995c16.575.918,31.882,8.4,34.2,16.709s-9.243,14.3-25.815,13.384-31.886-8.4-34.2-16.71,9.242-14.3,25.815-13.382Zm-.071-.247c-16.844-.936-28.593,5.156-26.239,13.6s17.919,16.051,34.763,16.986,28.594-5.159,26.242-13.6S2418.467,313.68,2401.619,312.748Z",
    transform: "translate(-2297.613 -316.567)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21144",
    "data-name": "Path 21144",
    d: "M2401.786,312.9c16.754.929,32.233,8.492,34.575,16.894s-9.345,14.459-26.1,13.532-32.235-8.492-34.575-16.894,9.343-14.459,26.1-13.532Zm-.071-.248c-17.028-.943-28.9,5.215-26.522,13.754s18.112,16.224,35.137,17.167,28.9-5.213,26.526-13.75S2418.745,313.6,2401.715,312.651Z",
    transform: "translate(-2297.753 -316.639)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21145",
    "data-name": "Path 21145",
    d: "M2401.881,312.8c16.936.939,32.584,8.584,34.952,17.077s-9.446,14.62-26.384,13.679-32.584-8.586-34.952-17.077,9.444-14.617,26.383-13.679Zm-.069-.247c-17.211-.953-29.213,5.267-26.809,13.9s18.305,16.4,35.516,17.353,29.212-5.269,26.807-13.9S2419.02,313.511,2401.812,312.558Z",
    transform: "translate(-2297.895 -316.709)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21146",
    "data-name": "Path 21146",
    d: "M2401.973,312.71c17.122.948,32.937,8.678,35.332,17.261s-9.548,14.775-26.667,13.825-32.935-8.678-35.329-17.262,9.548-14.771,26.664-13.823Zm-.066-.246c-17.4-.964-29.521,5.324-27.093,14.044s18.5,16.573,35.892,17.537,29.521-5.322,27.092-14.046S2419.3,313.427,2401.907,312.463Z",
    transform: "translate(-2298.037 -316.779)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21147",
    "data-name": "Path 21147",
    d: "M2402.072,312.615c17.3.958,33.285,8.768,35.7,17.443s-9.649,14.933-26.953,13.974-33.285-8.77-35.7-17.445,9.648-14.931,26.95-13.973Zm-.071-.247c-17.573-.976-29.831,5.378-27.374,14.191s18.692,16.743,36.268,17.721,29.829-5.381,27.375-14.191S2419.576,313.341,2402,312.369Z",
    transform: "translate(-2298.178 -316.849)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21148",
    "data-name": "Path 21148",
    d: "M2402.166,312.52c17.483.97,33.637,8.864,36.08,17.629s-9.751,15.087-27.235,14.12-33.638-8.86-36.08-17.627,9.753-15.091,27.235-14.122Zm-.067-.246c-17.758-.984-30.143,5.435-27.663,14.339s18.889,16.92,36.646,17.9,30.14-5.435,27.657-14.339S2419.853,313.258,2402.1,312.273Z",
    transform: "translate(-2298.32 -316.92)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21149",
    "data-name": "Path 21149",
    d: "M2402.259,312.428c17.667.977,33.987,8.952,36.457,17.811s-9.852,15.245-27.519,14.264-33.988-8.951-36.455-17.811,9.851-15.243,27.516-14.264Zm-.069-.25c-17.936-.993-30.449,5.493-27.94,14.488s19.078,17.092,37.018,18.087,30.449-5.491,27.943-14.487S2420.129,313.174,2402.19,312.178Z",
    transform: "translate(-2298.459 -316.991)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21150",
    "data-name": "Path 21150",
    d: "M2402.355,312.331c17.847.99,34.336,9.046,36.832,17.995s-9.955,15.4-27.8,14.414-34.335-9.046-36.832-17.993,9.953-15.4,27.8-14.415Zm-.069-.248c-18.12-1-30.76,5.548-28.225,14.634s19.271,17.267,37.394,18.271,30.758-5.548,28.225-14.632S2420.408,313.088,2402.287,312.083Z",
    transform: "translate(-2298.601 -317.062)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21151",
    "data-name": "Path 21151",
    d: "M2402.451,312.236c18.029,1,34.689,9.138,37.21,18.177s-10.057,15.561-28.088,14.561-34.686-9.138-37.207-18.177,10.058-15.561,28.085-14.561Zm-.068-.246c-18.306-1.017-31.067,5.6-28.511,14.78s19.469,17.439,37.771,18.455,31.067-5.605,28.511-14.782S2420.687,313,2402.383,311.99Z",
    transform: "translate(-2298.743 -317.132)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21152",
    "data-name": "Path 21152",
    d: "M2402.546,312.14c18.212,1.01,35.037,9.232,37.584,18.365s-10.157,15.716-28.368,14.707-35.042-9.23-37.583-18.363,10.155-15.717,28.367-14.709Zm-.069-.246c-18.484-1.024-31.375,5.659-28.794,14.927s19.661,17.615,38.148,18.639,31.376-5.661,28.792-14.929S2420.962,312.918,2402.477,311.894Z",
    transform: "translate(-2298.884 -317.202)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21153",
    "data-name": "Path 21153",
    d: "M2402.643,312.046c18.392,1.021,35.387,9.324,37.956,18.545s-10.257,15.877-28.651,14.856-35.389-9.32-37.957-18.545,10.256-15.875,28.652-14.856Zm-.072-.246c-18.665-1.035-31.684,5.715-29.077,15.073s19.858,17.788,38.523,18.825,31.686-5.718,29.079-15.077S2421.24,312.834,2402.571,311.8Z",
    transform: "translate(-2299.025 -317.273)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21154",
    "data-name": "Path 21154",
    d: "M2402.736,311.952c18.577,1.029,35.736,9.416,38.335,18.729s-10.36,16.032-28.938,15-35.737-9.414-38.333-18.727,10.358-16.033,28.936-15Zm-.07-.248c-18.849-1.043-31.995,5.77-29.36,15.223s20.046,17.96,38.9,19.005,32-5.77,29.364-15.223S2421.516,312.749,2402.666,311.7Z",
    transform: "translate(-2299.165 -317.344)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21155",
    "data-name": "Path 21155",
    d: "M2402.833,311.858c18.756,1.04,36.087,9.508,38.708,18.913s-10.463,16.188-29.219,15.148-36.091-9.508-38.71-18.913,10.463-16.188,29.222-15.148Zm-.07-.248c-19.031-1.055-32.306,5.826-29.645,15.368s20.24,18.134,39.272,19.191,32.3-5.828,29.645-15.372S2421.794,312.665,2402.763,311.609Z",
    transform: "translate(-2299.306 -317.414)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21156",
    "data-name": "Path 21156",
    d: "M2402.926,311.763c18.942,1.05,36.441,9.6,39.087,19.1s-10.564,16.344-29.5,15.3-36.438-9.6-39.086-19.1,10.565-16.348,29.5-15.3Zm-.068-.248c-19.215-1.066-32.613,5.881-29.93,15.516s20.439,18.309,39.65,19.372,32.614-5.881,29.931-15.516S2422.07,312.579,2402.858,311.515Z",
    transform: "translate(-2299.449 -317.485)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21157",
    "data-name": "Path 21157",
    d: "M2403.021,311.667c19.123,1.061,36.792,9.694,39.462,19.28s-10.665,16.505-29.786,15.443-36.792-9.69-39.464-19.28,10.664-16.5,29.787-15.443Zm-.07-.247c-19.4-1.076-32.922,5.937-30.21,15.662s20.628,18.483,40.025,19.557,32.919-5.937,30.211-15.665S2422.347,312.493,2402.951,311.42Z",
    transform: "translate(-2299.59 -317.555)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21158",
    "data-name": "Path 21158",
    d: "M2403.118,311.575c19.3,1.069,37.139,9.784,39.837,19.464s-10.765,16.66-30.071,15.591-37.14-9.784-39.836-19.464,10.765-16.662,30.07-15.591Zm-.069-.25c-19.578-1.085-33.232,5.994-30.5,15.809s20.825,18.658,40.4,19.741,33.23-5.993,30.5-15.809S2422.628,312.411,2403.048,311.325Z",
    transform: "translate(-2299.731 -317.626)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21159",
    "data-name": "Path 21159",
    d: "M2403.214,311.478c19.486,1.082,37.488,9.878,40.213,19.648s-10.871,16.818-30.357,15.736-37.492-9.876-40.213-19.646,10.867-16.818,30.356-15.738Zm-.071-.248c-19.759-1.1-33.541,6.05-30.781,15.959s21.018,18.826,40.78,19.924,33.54-6.05,30.78-15.959S2422.9,312.325,2403.143,311.23Z",
    transform: "translate(-2299.872 -317.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21160",
    "data-name": "Path 21160",
    d: "M2403.307,311.384c19.671,1.09,37.843,9.968,40.59,19.832s-10.97,16.974-30.639,15.884-37.842-9.97-40.588-19.832,10.97-16.974,30.637-15.884Zm-.071-.248c-19.941-1.106-33.85,6.105-31.062,16.1s21.212,19,41.153,20.108,33.849-6.105,31.063-16.106S2423.179,312.24,2403.236,311.135Z",
    transform: "translate(-2300.013 -317.767)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21161",
    "data-name": "Path 21161",
    d: "M2403.4,311.287c19.853,1.1,38.193,10.062,40.967,20.016s-11.07,17.13-30.922,16.032-38.193-10.063-40.966-20.016,11.073-17.132,30.921-16.031Zm-.065-.247c-20.125-1.116-34.16,6.161-31.35,16.25s21.406,19.177,41.53,20.29,34.158-6.161,31.348-16.248S2423.46,312.155,2403.335,311.041Z",
    transform: "translate(-2300.155 -317.837)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21162",
    "data-name": "Path 21162",
    d: "M2403.5,311.193c20.031,1.111,38.54,10.155,41.34,20.2s-11.173,17.287-31.206,16.177-38.543-10.155-41.342-20.2,11.173-17.288,31.208-16.179Zm-.071-.248c-20.3-1.125-34.468,6.218-31.629,16.4s21.6,19.349,41.906,20.474,34.466-6.216,31.629-16.4S2423.734,312.072,2403.427,310.945Z",
    transform: "translate(-2300.295 -317.908)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21163",
    "data-name": "Path 21163",
    d: "M2403.592,311.1c20.215,1.121,38.895,10.246,41.717,20.382s-11.271,17.448-31.49,16.325-38.89-10.244-41.715-20.382,11.273-17.446,31.488-16.325Zm-.069-.248c-20.488-1.135-34.776,6.272-31.916,16.547s21.8,19.522,42.283,20.656,34.776-6.27,31.912-16.545S2424.011,311.986,2403.523,310.851Z",
    transform: "translate(-2300.437 -317.979)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21164",
    "data-name": "Path 21164",
    d: "M2403.685,311c20.4,1.132,39.246,10.339,42.1,20.568s-11.377,17.6-31.773,16.472-39.244-10.338-42.093-20.566,11.375-17.6,31.77-16.474Zm-.068-.246c-20.668-1.146-35.085,6.328-32.2,16.691s21.986,19.7,42.656,20.844,35.086-6.329,32.2-16.693S2424.29,311.9,2403.617,310.756Z",
    transform: "translate(-2300.577 -318.049)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21165",
    "data-name": "Path 21165",
    d: "M2403.782,310.908c20.58,1.141,39.594,10.431,42.467,20.75s-11.475,17.761-32.056,16.618-39.592-10.428-42.467-20.746,11.476-17.762,32.056-16.622Zm-.069-.246c-20.852-1.156-35.394,6.383-32.481,16.84s22.179,19.868,43.033,21.024,35.394-6.385,32.48-16.839S2424.567,311.816,2403.713,310.662Z",
    transform: "translate(-2300.719 -318.119)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21166",
    "data-name": "Path 21166",
    d: "M2403.879,310.814c20.76,1.151,39.94,10.523,42.844,20.934s-11.579,17.919-32.341,16.768-39.943-10.525-42.842-20.934,11.575-17.919,32.34-16.768Zm-.071-.246c-21.033-1.167-35.7,6.439-32.766,16.985s22.376,20.045,43.409,21.21,35.705-6.44,32.766-16.988S2424.844,311.732,2403.808,310.567Z",
    transform: "translate(-2300.861 -318.19)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21167",
    "data-name": "Path 21167",
    d: "M2403.971,310.72c20.945,1.16,40.3,10.615,43.221,21.116s-11.681,18.075-32.625,16.913-40.29-10.614-43.22-21.116,11.681-18.075,32.624-16.913Zm-.068-.248c-21.215-1.177-36.014,6.5-33.05,17.134s22.568,20.217,43.783,21.394,36.014-6.494,33.051-17.134S2425.12,311.649,2403.9,310.471Z",
    transform: "translate(-2301.001 -318.261)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21168",
    "data-name": "Path 21168",
    d: "M2404.067,310.625c21.125,1.17,40.645,10.707,43.593,21.3s-11.78,18.231-32.9,17.061-40.645-10.707-43.6-21.3,11.782-18.233,32.907-17.061Zm-.07-.248c-21.4-1.187-36.321,6.552-33.331,17.281s22.761,20.391,44.158,21.576,36.323-6.551,33.333-17.281S2425.4,311.563,2404,310.377Z",
    transform: "translate(-2301.142 -318.331)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21169",
    "data-name": "Path 21169",
    d: "M2404.161,310.529c21.309,1.182,41,10.8,43.974,21.484s-11.883,18.389-33.191,17.209-40.994-10.8-43.971-21.484,11.882-18.389,33.189-17.209Zm-.068-.247c-21.583-1.2-36.63,6.607-33.617,17.427s22.955,20.564,44.535,21.758,36.632-6.6,33.619-17.425S2425.675,311.477,2404.094,310.282Z",
    transform: "translate(-2301.283 -318.401)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21170",
    "data-name": "Path 21170",
    d: "M2404.259,310.435c21.49,1.191,41.344,10.893,44.345,21.668s-11.984,18.547-33.473,17.356-41.347-10.893-44.348-21.67,11.983-18.545,33.476-17.354Zm-.071-.248c-21.762-1.207-36.939,6.664-33.9,17.577s23.145,20.738,44.909,21.944,36.94-6.663,33.9-17.577S2425.951,311.395,2404.188,310.187Z",
    transform: "translate(-2301.425 -318.472)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21171",
    "data-name": "Path 21171",
    d: "M2404.354,310.341c21.671,1.2,41.7,10.985,44.723,21.85s-12.085,18.7-33.759,17.5-41.7-10.982-44.725-21.85,12.087-18.7,33.761-17.5Zm-.072-.248c-21.945-1.217-37.248,6.718-34.183,17.724s23.342,20.911,45.287,22.125,37.25-6.718,34.185-17.721S2426.23,311.309,2404.282,310.092Z",
    transform: "translate(-2301.566 -318.543)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21172",
    "data-name": "Path 21172",
    d: "M2404.448,310.244c21.856,1.212,42.047,11.079,45.1,22.036s-12.188,18.859-34.042,17.649-42.047-11.077-45.1-22.036,12.187-18.859,34.042-17.649Zm-.07-.247c-22.127-1.225-37.557,6.774-34.468,17.868s23.534,21.083,45.665,22.312,37.559-6.774,34.467-17.87S2426.507,311.223,2404.379,310Z",
    transform: "translate(-2301.708 -318.613)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21173",
    "data-name": "Path 21173",
    d: "M2404.544,310.15c22.034,1.222,42.4,11.171,45.476,22.22s-12.293,19.016-34.327,17.794-42.4-11.167-45.475-22.219,12.289-19.016,34.327-17.8Zm-.069-.247c-22.309-1.238-37.868,6.829-34.751,18.018s23.729,21.257,46.036,22.493,37.872-6.829,34.754-18.017S2426.785,311.137,2404.474,309.9Z",
    transform: "translate(-2301.848 -318.684)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21174",
    "data-name": "Path 21174",
    d: "M2404.638,310.056c22.219,1.231,42.749,11.261,45.851,22.4s-12.391,19.174-34.61,17.945-42.745-11.261-45.85-22.4,12.392-19.174,34.609-17.943Zm-.069-.248c-22.49-1.245-38.178,6.887-35.034,18.165s23.923,21.43,46.416,22.677,38.178-6.885,35.033-18.163S2427.061,311.054,2404.568,309.807Z",
    transform: "translate(-2301.99 -318.754)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21175",
    "data-name": "Path 21175",
    d: "M2404.734,309.961c22.4,1.243,43.1,11.353,46.225,22.586s-12.492,19.33-34.893,18.089-43.1-11.353-46.229-22.585,12.5-19.332,34.9-18.09Zm-.071-.248c-22.673-1.257-38.484,6.94-35.318,18.311s24.116,21.606,46.791,22.861,38.486-6.942,35.318-18.311S2427.337,310.97,2404.663,309.713Z",
    transform: "translate(-2302.131 -318.825)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21176",
    "data-name": "Path 21176",
    d: "M2404.83,309.867c22.58,1.25,43.446,11.445,46.6,22.771s-12.593,19.486-35.177,18.236-43.446-11.445-46.6-22.771,12.594-19.488,35.179-18.236Zm-.07-.248c-22.857-1.267-38.8,7-35.6,18.457s24.309,21.778,47.165,23.046,38.8-7,35.6-18.458S2427.616,310.884,2404.76,309.618Z",
    transform: "translate(-2302.271 -318.895)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21177",
    "data-name": "Path 21177",
    d: "M2404.924,309.77c22.765,1.262,43.8,11.539,46.979,22.955s-12.7,19.646-35.458,18.384-43.8-11.539-46.982-22.953,12.7-19.646,35.462-18.386Zm-.068-.247c-23.038-1.278-39.105,7.053-35.887,18.606s24.5,21.949,47.542,23.227,39.1-7.053,35.888-18.606S2427.892,310.8,2404.855,309.524Z",
    transform: "translate(-2302.414 -318.966)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21178",
    "data-name": "Path 21178",
    d: "M2405.019,309.676c22.948,1.272,44.149,11.631,47.352,23.137s-12.8,19.8-35.742,18.531-44.149-11.631-47.355-23.137,12.8-19.8,35.745-18.531Zm-.068-.248c-23.222-1.286-39.415,7.11-36.172,18.753s24.7,22.125,47.92,23.413,39.415-7.111,36.17-18.754S2428.17,310.716,2404.951,309.428Z",
    transform: "translate(-2302.554 -319.037)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21179",
    "data-name": "Path 21179",
    d: "M2405.114,309.584c23.13,1.279,44.5,11.721,47.73,23.319s-12.9,19.96-36.028,18.679-44.5-11.723-47.73-23.323,12.9-19.958,36.028-18.675Zm-.068-.25c-23.4-1.3-39.724,7.164-36.455,18.9s24.892,22.3,48.292,23.6,39.725-7.164,36.456-18.9S2428.449,310.63,2405.046,309.334Z",
    transform: "translate(-2302.696 -319.107)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21180",
    "data-name": "Path 21180",
    d: "M2405.21,309.486c23.309,1.292,44.848,11.817,48.107,23.5s-13,20.116-36.311,18.826-44.85-11.815-48.108-23.5,13-20.116,36.313-18.826Zm-.069-.246c-23.583-1.307-40.033,7.22-36.739,19.045s25.087,22.474,48.669,23.781,40.035-7.22,36.739-19.047S2428.723,310.546,2405.14,309.239Z",
    transform: "translate(-2302.836 -319.177)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21181",
    "data-name": "Path 21181",
    d: "M2405.305,309.393c23.493,1.3,45.2,11.905,48.478,23.687s-13.1,20.276-36.592,18.972-45.2-11.907-48.482-23.689,13.1-20.273,36.6-18.971Zm-.071-.25c-23.766-1.316-40.342,7.277-37.02,19.194s25.279,22.646,49.044,23.963,40.341-7.275,37.019-19.193S2429,310.463,2405.234,309.143Z",
    transform: "translate(-2302.978 -319.248)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21182",
    "data-name": "Path 21182",
    d: "M2405.4,309.3c23.676,1.312,45.551,12,48.86,23.873s-13.206,20.432-36.881,19.12-45.55-12-48.857-23.873,13.2-20.432,36.878-19.12Zm-.066-.248c-23.949-1.326-40.655,7.333-37.308,19.34s25.474,22.819,49.423,24.147,40.649-7.331,37.3-19.34S2429.279,310.377,2405.333,309.049Z",
    transform: "translate(-2303.12 -319.319)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21183",
    "data-name": "Path 21183",
    d: "M2405.5,309.2c23.857,1.319,45.9,12.091,49.233,24.055s-13.307,20.587-37.163,19.264-45.9-12.091-49.233-24.053,13.3-20.59,37.163-19.266Zm-.072-.25c-24.131-1.337-40.958,7.388-37.586,19.488s25.664,22.995,49.8,24.331,40.959-7.388,37.59-19.488S2429.554,310.293,2405.424,308.954Z",
    transform: "translate(-2303.26 -319.389)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21184",
    "data-name": "Path 21184",
    d: "M2405.59,309.108c24.04,1.331,46.249,12.185,49.606,24.237s-13.4,20.746-37.443,19.413-46.25-12.183-49.61-24.239,13.406-20.745,37.446-19.412Zm-.07-.248c-24.312-1.347-41.267,7.442-37.873,19.634s25.862,23.166,50.174,24.515,41.269-7.444,37.872-19.635S2429.832,310.207,2405.521,308.86Z",
    transform: "translate(-2303.402 -319.46)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21185",
    "data-name": "Path 21185",
    d: "M2405.685,309.014c24.223,1.342,46.6,12.277,49.985,24.421s-13.507,20.9-37.729,19.561-46.6-12.277-49.987-24.421,13.509-20.9,37.731-19.561Zm-.069-.25c-24.494-1.357-41.578,7.5-38.156,19.783s26.055,23.34,50.551,24.7,41.579-7.5,38.155-19.781S2430.111,310.124,2405.615,308.764Z",
    transform: "translate(-2303.543 -319.531)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21186",
    "data-name": "Path 21186",
    d: "M2405.781,308.918c24.4,1.352,46.949,12.37,50.36,24.607s-13.612,21.059-38.014,19.707-46.95-12.369-50.36-24.605,13.608-21.061,38.014-19.708Zm-.07-.248c-24.678-1.366-41.889,7.557-38.439,19.929s26.246,23.513,50.924,24.882,41.889-7.553,38.438-19.929S2430.386,310.038,2405.711,308.67Z",
    transform: "translate(-2303.684 -319.601)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21187",
    "data-name": "Path 21187",
    d: "M2405.873,308.823c24.588,1.363,47.3,12.463,50.737,24.788s-13.711,21.22-38.3,19.858-47.3-12.461-50.735-24.791,13.712-21.217,38.3-19.854Zm-.068-.248c-24.857-1.377-42.2,7.612-38.724,20.076s26.442,23.687,51.3,25.064,42.2-7.609,38.723-20.075S2430.665,309.952,2405.806,308.575Z",
    transform: "translate(-2303.826 -319.671)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21188",
    "data-name": "Path 21188",
    d: "M2405.971,308.73c24.769,1.373,47.65,12.554,51.111,24.973s-13.811,21.375-38.581,20-47.652-12.553-51.112-24.973,13.813-21.377,38.582-20Zm-.069-.25c-25.043-1.387-42.507,7.666-39.007,20.224s26.635,23.861,51.676,25.25,42.507-7.666,39.007-20.222S2430.943,309.87,2405.9,308.48Z",
    transform: "translate(-2303.966 -319.742)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21189",
    "data-name": "Path 21189",
    d: "M2406.063,308.633c24.953,1.384,48,12.646,51.49,25.156s-13.913,21.535-38.866,20.151-48-12.646-51.487-25.156,13.914-21.533,38.863-20.151Zm-.066-.246c-25.225-1.4-42.815,7.722-39.292,20.37s26.828,24.034,52.051,25.432,42.816-7.721,39.29-20.37S2431.219,309.784,2406,308.386Z",
    transform: "translate(-2304.107 -319.812)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21190",
    "data-name": "Path 21190",
    d: "M2406.16,308.54c25.135,1.392,48.353,12.737,51.865,25.34s-14.018,21.689-39.151,20.3-48.35-12.738-51.864-25.341,14.017-21.689,39.149-20.3Zm-.067-.25c-25.406-1.408-43.125,7.779-39.577,20.517s27.026,24.208,52.429,25.616,43.125-7.777,39.575-20.517S2431.5,309.7,2406.093,308.29Z",
    transform: "translate(-2304.249 -319.883)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21191",
    "data-name": "Path 21191",
    d: "M2406.253,308.444c25.317,1.4,48.7,12.829,52.242,25.524s-14.119,21.847-39.432,20.443-48.7-12.83-52.239-25.524,14.115-21.845,39.429-20.443Zm-.066-.248c-25.592-1.418-43.436,7.834-39.858,20.665s27.215,24.382,52.8,25.8,43.429-7.834,39.856-20.665S2431.772,309.614,2406.188,308.2Z",
    transform: "translate(-2304.389 -319.954)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21192",
    "data-name": "Path 21192",
    d: "M2406.349,308.35c25.5,1.413,49.055,12.921,52.617,25.708s-14.219,22-39.717,20.59-49.055-12.922-52.615-25.706,14.219-22.007,39.715-20.592Zm-.067-.248c-25.77-1.429-43.743,7.89-40.143,20.811s27.411,24.555,53.179,25.984,43.742-7.888,40.14-20.812S2432.051,309.53,2406.282,308.1Z",
    transform: "translate(-2304.531 -320.024)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21193",
    "data-name": "Path 21193",
    d: "M2406.446,308.255c25.68,1.422,49.4,13.014,52.991,25.89s-14.321,22.161-40,20.738-49.4-13.014-52.992-25.892,14.324-22.161,40-20.736Zm-.07-.248c-25.953-1.439-44.052,7.944-40.426,20.958s27.605,24.727,53.556,26.166,44.05-7.944,40.425-20.958S2432.327,309.444,2406.377,308.007Z",
    transform: "translate(-2304.672 -320.094)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21194",
    "data-name": "Path 21194",
    d: "M2406.54,308.159c25.86,1.434,49.754,13.106,53.367,26.076s-14.421,22.316-40.283,20.882-49.753-13.1-53.367-26.074,14.42-22.316,40.283-20.884Zm-.068-.248c-26.135-1.448-44.363,8-40.71,21.106s27.8,24.9,53.933,26.35,44.359-8,40.707-21.1S2432.605,309.361,2406.472,307.911Z",
    transform: "translate(-2304.813 -320.165)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21195",
    "data-name": "Path 21195",
    d: "M2406.634,308.065c26.046,1.443,50.107,13.2,53.745,26.256s-14.524,22.475-40.568,21.035-50.107-13.2-53.744-26.26,14.526-22.475,40.566-21.031Zm-.068-.248c-26.315-1.458-44.669,8.055-40.992,21.253s27.992,25.074,54.307,26.532,44.67-8.055,40.993-21.252S2432.883,309.275,2406.566,307.817Z",
    transform: "translate(-2304.955 -320.236)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21196",
    "data-name": "Path 21196",
    d: "M2406.732,307.97c26.225,1.453,50.454,13.29,54.117,26.442s-14.624,22.632-40.85,21.177-50.453-13.29-54.117-26.442,14.626-22.632,40.851-21.177Zm-.071-.248c-26.5-1.469-44.979,8.112-41.276,21.4s28.185,25.249,54.682,26.718,44.979-8.114,41.277-21.4S2433.161,309.191,2406.661,307.722Z",
    transform: "translate(-2305.095 -320.306)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21197",
    "data-name": "Path 21197",
    d: "M2406.825,307.876c26.407,1.462,50.806,13.382,54.5,26.626s-14.727,22.788-41.133,21.324-50.806-13.384-54.5-26.626,14.726-22.79,41.134-21.324Zm-.068-.25c-26.68-1.477-45.29,8.168-41.561,21.548s28.379,25.42,55.059,26.9,45.288-8.168,41.559-21.545S2433.437,309.105,2406.758,307.626Z",
    transform: "translate(-2305.237 -320.377)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21198",
    "data-name": "Path 21198",
    d: "M2406.921,307.782c26.592,1.472,51.157,13.474,54.872,26.807s-14.831,22.948-41.418,21.474-51.155-13.475-54.872-26.81,14.829-22.946,41.418-21.47Zm-.07-.25c-26.862-1.488-45.6,8.223-41.844,21.694s28.572,25.6,55.436,27.084,45.6-8.223,41.844-21.694S2433.714,309.021,2406.852,307.532Z",
    transform: "translate(-2305.378 -320.447)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21199",
    "data-name": "Path 21199",
    d: "M2407.019,307.686c26.768,1.482,51.5,13.57,55.243,26.994s-14.931,23.1-41.7,21.62-51.507-13.57-55.248-26.994,14.931-23.1,41.7-21.62Zm-.071-.248c-27.045-1.5-45.906,8.279-42.128,21.842s28.767,25.769,55.813,27.268,45.9-8.28,42.125-21.842S2433.992,308.937,2406.948,307.437Z",
    transform: "translate(-2305.519 -320.518)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21200",
    "data-name": "Path 21200",
    d: "M2407.111,307.591c26.955,1.493,51.857,13.662,55.624,27.176s-15.032,23.26-41.986,21.766-51.857-13.66-55.624-27.176,15.034-23.26,41.986-21.766Zm-.069-.248c-27.227-1.51-46.215,8.336-42.411,21.988s28.959,25.944,56.186,27.452,46.217-8.336,42.411-21.988S2434.271,308.851,2407.042,307.343Z",
    transform: "translate(-2305.661 -320.588)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21201",
    "data-name": "Path 21201",
    d: "M2407.206,307.5c27.137,1.5,52.209,13.75,56,27.359s-15.132,23.42-42.268,21.915-52.205-13.754-56-27.36,15.131-23.418,42.266-21.913Zm-.067-.248c-27.41-1.521-46.526,8.392-42.7,22.135S2393.6,355.5,2421,357.016s46.526-8.39,42.7-22.133S2434.546,308.766,2407.139,307.248Z",
    transform: "translate(-2305.802 -320.659)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21202",
    "data-name": "Path 21202",
    d: "M2407.3,307.4c27.319,1.514,52.558,13.846,56.377,27.544s-15.238,23.574-42.556,22.061-52.555-13.846-56.373-27.544,15.236-23.574,42.552-22.061Zm-.068-.248c-27.591-1.529-46.835,8.447-42.977,22.281s29.346,26.291,56.938,27.82,46.833-8.447,42.979-22.283S2434.825,308.682,2407.232,307.153Z",
    transform: "translate(-2305.943 -320.73)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21203",
    "data-name": "Path 21203",
    d: "M2407.4,307.306c27.5,1.524,52.906,13.938,56.749,27.728s-15.336,23.731-42.835,22.206-52.909-13.936-56.752-27.727,15.338-23.732,42.838-22.208Zm-.071-.248c-27.771-1.538-47.14,8.5-43.262,22.43s29.541,26.461,57.315,28,47.143-8.5,43.262-22.427S2435.1,308.6,2407.326,307.058Z",
    transform: "translate(-2306.084 -320.8)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21204",
    "data-name": "Path 21204",
    d: "M2407.49,307.212c27.684,1.533,53.259,14.03,57.125,27.911s-15.434,23.889-43.118,22.354-53.257-14.03-57.125-27.911,15.436-23.889,43.118-22.354Zm-.066-.248c-27.956-1.55-47.452,8.557-43.546,22.576s29.732,26.637,57.689,28.188,47.451-8.56,43.544-22.578S2435.379,308.512,2407.424,306.964Z",
    transform: "translate(-2306.224 -320.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21205",
    "data-name": "Path 21205",
    d: "M2407.585,307.118c27.864,1.543,53.61,14.122,57.5,28.095s-15.538,24.045-43.4,22.5-53.606-14.124-57.5-28.095,15.542-24.046,43.4-22.5Zm-.07-.25c-28.137-1.559-47.759,8.614-43.827,22.724s29.926,26.812,58.064,28.371,47.763-8.614,43.83-22.724S2435.654,308.429,2407.516,306.868Z",
    transform: "translate(-2306.366 -320.941)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21206",
    "data-name": "Path 21206",
    d: "M2407.683,307.022c28.046,1.555,53.959,14.214,57.877,28.281s-15.641,24.2-43.687,22.649-53.96-14.216-57.877-28.281,15.639-24.2,43.687-22.649Zm-.07-.248c-28.32-1.569-48.07,8.669-44.114,22.871s30.123,26.982,58.444,28.555,48.068-8.671,44.111-22.871S2435.933,308.343,2407.613,306.773Z",
    transform: "translate(-2306.508 -321.012)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21207",
    "data-name": "Path 21207",
    d: "M2407.776,306.927c28.23,1.564,54.31,14.308,58.254,28.461s-15.742,24.362-43.971,22.8-54.309-14.31-58.253-28.463,15.741-24.361,43.97-22.8Zm-.07-.248c-28.5-1.58-48.377,8.725-44.4,23.019s30.312,27.156,58.816,28.737,48.377-8.727,44.4-23.019S2436.21,308.259,2407.707,306.679Z",
    transform: "translate(-2306.649 -321.082)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21208",
    "data-name": "Path 21208",
    d: "M2407.874,306.833c28.407,1.574,54.658,14.4,58.627,28.645s-15.842,24.519-44.255,22.944-54.658-14.4-58.63-28.647,15.844-24.517,44.258-22.942Zm-.071-.248c-28.683-1.59-48.689,8.781-44.68,23.163s30.507,27.333,59.192,28.923,48.687-8.782,44.678-23.165S2436.486,308.174,2407.8,306.584Z",
    transform: "translate(-2306.79 -321.152)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21209",
    "data-name": "Path 21209",
    d: "M2407.968,306.737c28.593,1.587,55.009,14.492,59.005,28.831s-15.948,24.675-44.54,23.09-55.011-14.493-59.005-28.829,15.947-24.675,44.54-23.092Zm-.071-.248c-28.865-1.6-49,8.838-44.962,23.314s30.7,27.5,59.567,29.1,49-8.836,44.965-23.31S2436.763,308.089,2407.9,306.489Z",
    transform: "translate(-2306.931 -321.223)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21210",
    "data-name": "Path 21210",
    d: "M2408.061,306.642c28.775,1.6,55.361,14.584,59.382,29.015s-16.047,24.831-44.82,23.236-55.362-14.584-59.38-29.013,16.047-24.833,44.819-23.238Zm-.067-.247c-29.049-1.611-49.307,8.892-45.25,23.458s30.9,27.68,59.946,29.289,49.307-8.893,45.248-23.461S2437.043,308,2407.994,306.4Z",
    transform: "translate(-2307.073 -321.293)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21211",
    "data-name": "Path 21211",
    d: "M2408.158,306.548c28.956,1.6,55.71,14.676,59.757,29.2s-16.15,24.991-45.107,23.387-55.71-14.677-59.755-29.2,16.149-24.989,45.105-23.385Zm-.068-.248c-29.231-1.62-49.617,8.949-45.534,23.606s31.091,27.85,60.321,29.471,49.616-8.947,45.532-23.6S2437.319,307.919,2408.09,306.3Z",
    transform: "translate(-2307.214 -321.364)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21212",
    "data-name": "Path 21212",
    d: "M2408.253,306.452c29.139,1.616,56.061,14.769,60.132,29.383s-16.249,25.145-45.39,23.531-56.063-14.77-60.132-29.379,16.249-25.147,45.39-23.534Zm-.069-.247c-29.412-1.63-49.926,9-45.815,23.751s31.285,28.027,60.7,29.659,49.922-9.006,45.812-23.755S2437.6,307.835,2408.184,306.2Z",
    transform: "translate(-2307.354 -321.435)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21213",
    "data-name": "Path 21213",
    d: "M2408.347,306.357c29.322,1.625,56.412,14.862,60.509,29.563s-16.351,25.3-45.673,23.682-56.412-14.863-60.509-29.565,16.353-25.305,45.673-23.68Zm-.069-.247c-29.593-1.64-50.232,9.058-46.1,23.9s31.478,28.2,61.07,29.838,50.234-9.06,46.1-23.9S2437.874,307.749,2408.278,306.11Z",
    transform: "translate(-2307.496 -321.505)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21214",
    "data-name": "Path 21214",
    d: "M2408.444,306.263c29.5,1.635,56.76,14.953,60.885,29.747s-16.455,25.461-45.959,23.828-56.762-14.955-60.883-29.749,16.455-25.461,45.958-23.826Zm-.067-.248c-29.779-1.649-50.544,9.117-46.387,24.046s31.673,28.374,61.448,30.023,50.544-9.116,46.383-24.046S2438.151,307.664,2408.376,306.015Z",
    transform: "translate(-2307.637 -321.576)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21215",
    "data-name": "Path 21215",
    d: "M2408.536,306.169c29.687,1.646,57.115,15.046,61.26,29.931s-16.554,25.617-46.24,23.972-57.109-15.045-61.257-29.93,16.554-25.619,46.237-23.974Zm-.068-.248c-29.958-1.661-50.851,9.171-46.666,24.194s31.865,28.546,61.823,30.207,50.853-9.173,46.668-24.194S2438.427,307.58,2408.468,305.92Z",
    transform: "translate(-2307.778 -321.646)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21216",
    "data-name": "Path 21216",
    d: "M2408.633,306.072c29.869,1.656,57.464,15.139,61.637,30.115s-16.657,25.776-46.524,24.121-57.464-15.139-61.637-30.114,16.656-25.775,46.524-24.123Zm-.068-.247c-30.142-1.67-51.162,9.227-46.953,24.34s32.062,28.721,62.2,30.391,51.162-9.228,46.95-24.342S2438.7,307.5,2408.565,305.826Z",
    transform: "translate(-2307.919 -321.717)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21217",
    "data-name": "Path 21217",
    d: "M2408.728,305.978c30.049,1.667,57.811,15.231,62.011,30.3s-16.757,25.935-46.808,24.269-57.813-15.231-62.012-30.3,16.758-25.932,46.809-24.267Zm-.07-.247c-30.322-1.68-51.471,9.282-47.234,24.487s32.25,28.893,62.576,30.574,51.47-9.284,47.232-24.487S2438.982,307.412,2408.659,305.731Z",
    transform: "translate(-2308.06 -321.787)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21218",
    "data-name": "Path 21218",
    d: "M2408.822,305.884c30.232,1.677,58.166,15.323,62.389,30.483s-16.861,26.09-47.093,24.413-58.162-15.323-62.386-30.48,16.861-26.091,47.091-24.416Zm-.068-.248c-30.506-1.689-51.78,9.34-47.518,24.637s32.448,29.063,62.951,30.756,51.778-9.339,47.517-24.635S2439.259,307.328,2408.755,305.635Z",
    transform: "translate(-2308.201 -321.858)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21219",
    "data-name": "Path 21219",
    d: "M2408.917,305.789c30.415,1.686,58.515,15.415,62.763,30.664s-16.962,26.249-47.374,24.564-58.514-15.415-62.763-30.666,16.962-26.248,47.374-24.562Zm-.068-.248c-30.687-1.7-52.09,9.4-47.8,24.783s32.641,29.24,63.329,30.94,52.084-9.393,47.8-24.783S2439.536,307.242,2408.85,305.541Z",
    transform: "translate(-2308.343 -321.928)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21220",
    "data-name": "Path 21220",
    d: "M2409.013,305.695c30.6,1.7,58.865,15.506,63.138,30.85s-17.064,26.4-47.657,24.706-58.864-15.506-63.138-30.85,17.061-26.4,47.657-24.706Zm-.07-.248c-30.869-1.712-52.4,9.449-48.084,24.928s32.834,29.414,63.7,31.127,52.4-9.452,48.084-24.932S2439.814,307.156,2408.943,305.446Z",
    transform: "translate(-2308.484 -321.999)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21221",
    "data-name": "Path 21221",
    d: "M2409.11,305.6c30.778,1.706,59.212,15.6,63.515,31.035s-17.164,26.558-47.944,24.855-59.213-15.6-63.515-31.034,17.165-26.562,47.944-24.857Zm-.071-.246c-31.05-1.722-52.7,9.5-48.37,25.076s33.028,29.586,64.081,31.308,52.707-9.506,48.367-25.076S2440.093,307.072,2409.039,305.352Z",
    transform: "translate(-2308.625 -322.069)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21222",
    "data-name": "Path 21222",
    d: "M2409.2,305.5c30.959,1.715,59.568,15.693,63.892,31.216s-17.268,26.718-48.228,25-59.565-15.691-63.889-31.216,17.265-26.718,48.225-25Zm-.067-.248c-31.235-1.731-53.016,9.563-48.652,25.223s33.219,29.761,64.454,31.49,53.015-9.56,48.65-25.223S2440.366,306.987,2409.135,305.256Z",
    transform: "translate(-2308.766 -322.14)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21223",
    "data-name": "Path 21223",
    d: "M2409.3,305.41c31.142,1.726,59.915,15.783,64.265,31.4s-17.366,26.874-48.507,25.147-59.919-15.783-64.269-31.4,17.368-26.874,48.511-25.149Zm-.069-.248c-31.416-1.741-53.325,9.617-48.935,25.371s33.414,29.933,64.829,31.674,53.325-9.617,48.937-25.369S2440.645,306.9,2409.23,305.162Z",
    transform: "translate(-2308.907 -322.211)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21224",
    "data-name": "Path 21224",
    d: "M2409.394,305.315c31.326,1.736,60.265,15.875,64.644,31.582s-17.471,27.034-48.795,25.3-60.267-15.877-64.642-31.586,17.467-27.031,48.792-25.295Zm-.068-.248c-31.6-1.752-53.636,9.673-49.221,25.518s33.608,30.107,65.206,31.858,53.634-9.674,49.22-25.517S2440.921,306.817,2409.326,305.067Z",
    transform: "translate(-2309.049 -322.281)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21225",
    "data-name": "Path 21225",
    d: "M2409.488,305.222c31.506,1.745,60.615,15.967,65.018,31.766s-17.571,27.19-49.077,25.442-60.616-15.967-65.021-31.765,17.573-27.192,49.079-25.444Zm-.067-.25c-31.781-1.762-53.946,9.73-49.5,25.666s33.8,30.28,65.585,32.042,53.941-9.73,49.5-25.664S2441.2,306.734,2409.421,304.972Z",
    transform: "translate(-2309.19 -322.352)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21226",
    "data-name": "Path 21226",
    d: "M2409.583,305.125c31.686,1.757,60.967,16.061,65.4,31.952s-17.674,27.347-49.362,25.59-60.968-16.061-65.395-31.952,17.674-27.347,49.362-25.59Zm-.07-.248c-31.961-1.771-54.252,9.784-49.785,25.812s34,30.456,65.959,32.226,54.249-9.784,49.783-25.812S2441.476,306.649,2409.514,304.877Z",
    transform: "translate(-2309.331 -322.422)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21227",
    "data-name": "Path 21227",
    d: "M2409.678,305.032c31.873,1.764,61.317,16.151,65.77,32.132s-17.774,27.506-49.643,25.739-61.319-16.155-65.77-32.136,17.774-27.5,49.643-25.736Zm-.069-.25c-32.141-1.781-54.562,9.839-50.071,25.96s34.192,30.627,66.335,32.409,54.561-9.839,50.072-25.956S2441.754,306.563,2409.609,304.782Z",
    transform: "translate(-2309.472 -322.493)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21228",
    "data-name": "Path 21228",
    d: "M2409.775,304.936c32.051,1.776,61.668,16.245,66.147,32.317s-17.877,27.662-49.931,25.885-61.667-16.245-66.145-32.318,17.875-27.661,49.929-25.883Zm-.068-.248c-32.327-1.793-54.874,9.9-50.357,26.105s34.385,30.8,66.711,32.593,54.871-9.9,50.354-26.105S2442.031,306.48,2409.707,304.688Z",
    transform: "translate(-2309.613 -322.563)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21229",
    "data-name": "Path 21229",
    d: "M2409.87,304.842c32.233,1.785,62.017,16.337,66.522,32.5s-17.979,27.819-50.213,26.032-62.019-16.339-66.523-32.5,17.977-27.819,50.214-26.031Zm-.072-.25c-32.507-1.8-55.177,9.954-50.636,26.251s34.575,30.978,67.083,32.78,55.182-9.952,50.639-26.253S2442.308,306.4,2409.8,304.592Z",
    transform: "translate(-2309.754 -322.634)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21230",
    "data-name": "Path 21230",
    d: "M2409.964,304.746c32.417,1.8,62.37,16.431,66.9,32.686s-18.08,27.975-50.5,26.18-62.366-16.431-66.9-32.688,18.079-27.975,50.5-26.178Zm-.069-.248c-32.69-1.811-55.488,10.008-50.921,26.4s34.771,31.148,67.461,32.962,55.488-10.009,50.921-26.4S2442.585,306.31,2409.9,304.5Z",
    transform: "translate(-2309.895 -322.704)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21231",
    "data-name": "Path 21231",
    d: "M2410.06,304.651c32.6,1.807,62.716,16.523,67.271,32.869s-18.178,28.133-50.78,26.326-62.716-16.523-67.273-32.867,18.181-28.135,50.782-26.327Zm-.07-.248c-32.874-1.823-55.8,10.063-51.206,26.548s34.964,31.322,67.836,33.145,55.8-10.065,51.206-26.548S2442.863,306.224,2409.991,304.4Z",
    transform: "translate(-2310.036 -322.775)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21232",
    "data-name": "Path 21232",
    d: "M2410.152,304.558c32.782,1.816,63.071,16.615,67.651,33.053s-18.284,28.291-51.063,26.473-63.068-16.615-67.65-33.053,18.281-28.293,51.062-26.473Zm-.067-.25c-33.054-1.831-56.106,10.121-51.488,26.694s35.157,31.5,68.21,33.329,56.108-10.119,51.489-26.694S2443.142,306.141,2410.085,304.308Z",
    transform: "translate(-2310.178 -322.846)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21233",
    "data-name": "Path 21233",
    d: "M2410.251,304.462c32.963,1.826,63.417,16.707,68.024,33.235s-18.384,28.449-51.346,26.621-63.421-16.709-68.023-33.235,18.38-28.449,51.345-26.621Zm-.071-.248c-33.235-1.844-56.415,10.174-51.773,26.84s35.353,31.669,68.589,33.514,56.417-10.176,51.773-26.843S2443.417,306.056,2410.18,304.214Z",
    transform: "translate(-2310.319 -322.916)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21234",
    "data-name": "Path 21234",
    d: "M2410.346,304.368c33.145,1.835,63.769,16.8,68.4,33.419s-18.484,28.6-51.631,26.767-63.769-16.8-68.4-33.419,18.485-28.605,51.631-26.767Zm-.067-.248c-33.422-1.854-56.728,10.23-52.06,26.987s35.548,31.843,68.968,33.695,56.722-10.23,52.054-26.987S2443.7,305.97,2410.279,304.12Z",
    transform: "translate(-2310.461 -322.986)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21235",
    "data-name": "Path 21235",
    d: "M2410.439,304.272c33.329,1.847,64.121,16.891,68.777,33.6s-18.585,28.763-51.916,26.916-64.116-16.893-68.776-33.6,18.59-28.761,51.916-26.914Zm-.069-.248c-33.6-1.863-57.033,10.286-52.339,27.133s35.737,32.021,69.34,33.881,57.031-10.287,52.338-27.135S2443.971,305.887,2410.37,304.024Z",
    transform: "translate(-2310.601 -323.057)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21236",
    "data-name": "Path 21236",
    d: "M2410.535,304.178c33.509,1.856,64.472,16.983,69.152,33.787s-18.688,28.919-52.2,27.062-64.471-16.985-69.152-33.787,18.686-28.919,52.2-27.062Zm-.069-.248c-33.783-1.873-57.344,10.343-52.624,27.282s35.931,32.188,69.717,34.063,57.344-10.345,52.623-27.282S2444.248,305.8,2410.466,303.929Z",
    transform: "translate(-2310.742 -323.127)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21237",
    "data-name": "Path 21237",
    d: "M2410.63,304.082c33.693,1.868,64.821,17.078,69.529,33.971s-18.79,29.077-52.484,27.209-64.82-17.077-69.527-33.971,18.788-29.076,52.481-27.209Zm-.071-.248c-33.962-1.882-57.649,10.4-52.905,27.43s36.127,32.365,70.093,34.247,57.651-10.4,52.905-27.43S2444.524,305.717,2410.559,303.834Z",
    transform: "translate(-2310.884 -323.198)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21238",
    "data-name": "Path 21238",
    d: "M2410.724,303.987c33.875,1.878,65.169,17.17,69.9,34.155s-18.892,29.234-52.766,27.355-65.17-17.167-69.9-34.155,18.891-29.233,52.765-27.355Zm-.068-.248c-34.148-1.892-57.962,10.454-53.19,27.576s36.318,32.539,70.465,34.431,57.963-10.454,53.193-27.576S2444.8,305.631,2410.656,303.739Z",
    transform: "translate(-2311.024 -323.269)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21239",
    "data-name": "Path 21239",
    d: "M2410.819,303.893c34.058,1.889,65.522,17.261,70.28,34.337s-18.991,29.393-53.049,27.5-65.522-17.261-70.28-34.336,18.991-29.392,53.049-27.5Zm-.069-.248c-34.329-1.9-58.271,10.51-53.473,27.723s36.51,32.712,70.841,34.615,58.271-10.511,53.477-27.725S2445.08,305.547,2410.75,303.645Z",
    transform: "translate(-2311.165 -323.339)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21240",
    "data-name": "Path 21240",
    d: "M2410.914,303.8c34.24,1.9,65.875,17.353,70.657,34.521s-19.095,29.548-53.333,27.65-65.873-17.354-70.655-34.523,19.094-29.546,53.332-27.649Zm-.07-.248c-34.511-1.913-58.577,10.565-53.756,27.871s36.707,32.886,71.218,34.8,58.58-10.567,53.759-27.873S2445.357,305.463,2410.844,303.55Z",
    transform: "translate(-2311.307 -323.409)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21241",
    "data-name": "Path 21241",
    d: "M2411.011,303.7c34.42,1.908,66.223,17.446,71.032,34.705s-19.2,29.706-53.617,27.8S2362.2,348.759,2357.4,331.5s19.2-29.706,53.615-27.8Zm-.068-.248c-34.7-1.922-58.891,10.622-54.044,28.018s36.9,33.058,71.595,34.981,58.891-10.621,54.044-28.017S2445.636,305.378,2410.943,303.454Z",
    transform: "translate(-2311.448 -323.48)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21242",
    "data-name": "Path 21242",
    d: "M2411.105,303.608c34.6,1.918,66.572,17.538,71.407,34.889s-19.3,29.862-53.9,27.944-66.574-17.538-71.409-34.888,19.3-29.864,53.9-27.945Zm-.07-.248c-34.875-1.934-59.2,10.678-54.325,28.166s37.1,33.231,71.969,35.164,59.2-10.676,54.327-28.166S2445.913,305.294,2411.036,303.36Z",
    transform: "translate(-2311.59 -323.551)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21243",
    "data-name": "Path 21243",
    d: "M2411.2,303.514c34.784,1.927,66.923,17.63,71.782,35.073s-19.4,30.018-54.183,28.091-66.923-17.63-71.783-35.073,19.4-30.02,54.184-28.091Zm-.069-.248c-35.058-1.943-59.507,10.733-54.608,28.312s37.288,33.405,72.346,35.347,59.508-10.73,54.608-28.312S2446.188,305.208,2411.131,303.265Z",
    transform: "translate(-2311.73 -323.621)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21244",
    "data-name": "Path 21244",
    d: "M2411.294,303.417c34.968,1.939,67.274,17.724,72.16,35.257s-19.5,30.176-54.467,28.239-67.274-17.724-72.16-35.257,19.5-30.174,54.467-28.239Zm-.069-.247c-35.24-1.953-59.814,10.787-54.891,28.458s37.481,33.579,72.721,35.535,59.817-10.789,54.893-28.461S2446.465,305.124,2411.225,303.171Z",
    transform: "translate(-2311.871 -323.692)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21245",
    "data-name": "Path 21245",
    d: "M2411.389,303.323c35.151,1.949,67.626,17.816,72.537,35.443s-19.6,30.332-54.752,28.383-67.624-17.814-72.535-35.44,19.6-30.334,54.75-28.386Zm-.067-.248c-35.423-1.962-60.125,10.844-55.176,28.609s37.676,33.752,73.1,35.714,60.125-10.844,55.177-28.605S2446.743,305.04,2411.322,303.075Z",
    transform: "translate(-2312.013 -323.763)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21246",
    "data-name": "Path 21246",
    d: "M2411.488,303.229c35.329,1.958,67.973,17.908,72.908,35.624s-19.7,30.492-55.033,28.532-67.975-17.908-72.91-35.624,19.7-30.49,55.035-28.532Zm-.069-.248c-35.6-1.972-60.435,10.9-55.462,28.753s37.87,33.926,73.474,35.9,60.436-10.9,55.462-28.754S2447.021,304.954,2411.418,302.981Z",
    transform: "translate(-2312.155 -323.833)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21247",
    "data-name": "Path 21247",
    d: "M2411.582,303.134c35.513,1.969,68.324,18,73.287,35.806s-19.807,30.648-55.318,28.68-68.328-18-73.289-35.806,19.805-30.648,55.319-28.68Zm-.071-.248c-35.783-1.982-60.743,10.956-55.743,28.9s38.066,34.1,73.85,36.084,60.746-10.956,55.745-28.9S2447.3,304.868,2411.51,302.886Z",
    transform: "translate(-2312.296 -323.903)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21248",
    "data-name": "Path 21248",
    d: "M2411.676,303.038c35.7,1.979,68.677,18.092,73.662,35.992s-19.908,30.8-55.6,28.827-68.675-18.09-73.661-35.992,19.907-30.8,55.6-28.827Zm-.069-.247c-35.969-1.995-61.055,11.011-56.026,29.048s38.256,34.271,74.225,36.264,61.053-11.011,56.027-29.046S2447.577,304.785,2411.606,302.792Z",
    transform: "translate(-2312.437 -323.974)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21249",
    "data-name": "Path 21249",
    d: "M2411.772,302.945c35.875,1.988,69.025,18.184,74.039,36.174s-20.009,30.961-55.887,28.971-69.025-18.181-74.039-36.172,20.007-30.963,55.887-28.973Zm-.071-.248c-36.151-2-61.361,11.067-56.31,29.194s38.45,34.447,74.6,36.45,61.36-11.068,56.309-29.2S2447.854,304.7,2411.7,302.7Z",
    transform: "translate(-2312.577 -324.044)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21250",
    "data-name": "Path 21250",
    d: "M2411.867,302.85c36.059,2,69.376,18.276,74.416,36.358s-20.111,31.12-56.17,29.121-69.376-18.276-74.414-36.358,20.109-31.119,56.169-29.121Zm-.07-.248c-36.331-2.014-61.672,11.122-56.6,29.341s38.646,34.622,74.978,36.634,61.673-11.121,56.6-29.341S2448.131,304.615,2411.8,302.6Z",
    transform: "translate(-2312.719 -324.115)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21251",
    "data-name": "Path 21251",
    d: "M2411.958,302.755c36.245,2.009,69.728,18.368,74.791,36.542s-20.21,31.277-56.448,29.27-69.729-18.372-74.792-36.544,20.211-31.277,56.45-29.268Zm-.066-.248c-36.515-2.024-61.982,11.178-56.877,29.49s38.835,34.792,75.351,36.814,61.983-11.178,56.88-29.487S2448.406,304.531,2411.892,302.507Z",
    transform: "translate(-2312.86 -324.186)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21252",
    "data-name": "Path 21252",
    d: "M2412.057,302.659c36.424,2.019,70.077,18.462,75.165,36.726s-20.314,31.435-56.737,29.416-70.076-18.462-75.166-36.726,20.314-31.433,56.739-29.416Zm-.069-.246c-36.7-2.035-62.29,11.233-57.162,29.634s39.031,34.969,75.728,37,62.293-11.235,57.164-29.636S2448.687,304.447,2411.987,302.412Z",
    transform: "translate(-2313.001 -324.256)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21253",
    "data-name": "Path 21253",
    d: "M2412.152,302.565c36.6,2.029,70.426,18.554,75.54,36.91s-20.414,31.591-57.021,29.562-70.425-18.554-75.54-36.91,20.415-31.589,57.021-29.562Zm-.07-.248c-36.88-2.043-62.6,11.291-57.445,29.784s39.224,35.141,76.1,37.184,62.6-11.291,57.445-29.782S2448.962,304.362,2412.082,302.317Z",
    transform: "translate(-2313.142 -324.327)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21254",
    "data-name": "Path 21254",
    d: "M2412.245,302.47c36.791,2.04,70.779,18.646,75.917,37.092s-20.514,31.751-57.3,29.709-70.777-18.644-75.917-37.092,20.517-31.747,57.3-29.709Zm-.065-.248c-37.063-2.054-62.909,11.346-57.731,29.931s39.42,35.313,76.479,37.367,62.909-11.346,57.731-29.93S2449.24,304.276,2412.179,302.222Z",
    transform: "translate(-2313.284 -324.397)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21255",
    "data-name": "Path 21255",
    d: "M2412.341,302.376c36.971,2.048,71.127,18.738,76.293,37.276s-20.618,31.907-57.588,29.855-71.127-18.738-76.292-37.274,20.617-31.905,57.587-29.857Zm-.068-.248c-37.243-2.064-63.218,11.4-58.013,30.075s39.613,35.49,76.854,37.552,63.219-11.4,58.014-30.075S2449.518,304.192,2412.273,302.128Z",
    transform: "translate(-2313.425 -324.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21256",
    "data-name": "Path 21256",
    d: "M2412.438,302.281c37.151,2.057,71.478,18.83,76.667,37.46s-20.719,32.061-57.871,30-71.478-18.832-76.667-37.462,20.718-32.06,57.871-30Zm-.071-.248c-37.422-2.074-63.525,11.457-58.3,30.223s39.807,35.662,77.234,37.734,63.525-11.457,58.3-30.223S2449.792,304.108,2412.366,302.033Z",
    transform: "translate(-2313.566 -324.538)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21257",
    "data-name": "Path 21257",
    d: "M2412.532,302.186c37.335,2.071,71.829,18.924,77.045,37.646s-20.823,32.219-58.155,30.15-71.83-18.925-77.045-37.644,20.821-32.221,58.155-30.152Zm-.069-.248c-37.606-2.083-63.834,11.515-58.58,30.371s40,35.837,77.607,37.922,63.836-11.515,58.583-30.372S2450.072,304.022,2412.462,301.937Z",
    transform: "translate(-2313.707 -324.609)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21258",
    "data-name": "Path 21258",
    d: "M2412.627,302.091c37.516,2.08,72.178,19.016,77.42,37.827s-20.922,32.379-58.439,30.3-72.18-19.018-77.42-37.828,20.922-32.377,58.439-30.3Zm-.07-.248c-37.788-2.094-64.146,11.568-58.863,30.518s40.192,36.009,77.985,38.1,64.141-11.568,58.861-30.518S2450.346,303.938,2412.558,301.843Z",
    transform: "translate(-2313.847 -324.679)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21259",
    "data-name": "Path 21259",
    d: "M2412.724,302c37.7,2.088,72.527,19.108,77.793,38.012s-21.023,32.53-58.72,30.443-72.53-19.108-77.8-38.011,21.026-32.535,58.724-30.445Zm-.069-.248c-37.973-2.1-64.453,11.624-59.149,30.664s40.391,36.183,78.361,38.288,64.453-11.626,59.148-30.666S2450.626,303.852,2412.654,301.748Z",
    transform: "translate(-2313.989 -324.75)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21260",
    "data-name": "Path 21260",
    d: "M2412.818,301.9c37.879,2.1,72.879,19.2,78.172,38.2s-21.126,32.69-59.009,30.589-72.877-19.2-78.172-38.193,21.128-32.691,59.009-30.593Zm-.071-.246c-38.151-2.116-64.761,11.679-59.43,30.811s40.582,36.354,78.736,38.47,64.763-11.681,59.432-30.813S2450.9,303.768,2412.747,301.654Z",
    transform: "translate(-2314.131 -324.82)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21261",
    "data-name": "Path 21261",
    d: "M2412.912,301.808c38.063,2.109,73.229,19.292,78.547,38.377s-21.225,32.848-59.289,30.739-73.23-19.292-78.543-38.377,21.224-32.848,59.286-30.739Zm-.069-.248c-38.335-2.127-65.071,11.735-59.715,30.959s40.776,36.528,79.113,38.653,65.071-11.735,59.714-30.959S2451.18,303.684,2412.843,301.559Z",
    transform: "translate(-2314.272 -324.891)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21262",
    "data-name": "Path 21262",
    d: "M2413.007,301.712c38.247,2.12,73.582,19.385,78.925,38.563s-21.332,33.006-59.575,30.886-73.579-19.385-78.923-38.564,21.329-33,59.573-30.884Zm-.07-.248c-38.517-2.134-65.379,11.794-60,31.1s40.97,36.705,79.489,38.839,65.38-11.792,60-31.107S2451.459,303.6,2412.937,301.464Z",
    transform: "translate(-2314.414 -324.961)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21263",
    "data-name": "Path 21263",
    d: "M2413.1,301.617c38.427,2.13,73.933,19.477,79.3,38.747s-21.431,33.16-59.857,31.03-73.931-19.476-79.3-38.743,21.428-33.164,59.858-31.034Zm-.07-.248c-38.7-2.146-65.69,11.848-60.284,31.254s41.164,36.875,79.864,39.021S2498.3,359.8,2492.9,340.39,2451.734,303.515,2413.034,301.369Z",
    transform: "translate(-2314.555 -325.032)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21264",
    "data-name": "Path 21264",
    d: "M2413.2,301.523c38.609,2.139,74.28,19.568,79.674,38.929s-21.532,33.318-60.141,31.18-74.281-19.568-79.673-38.929,21.53-33.32,60.141-31.18Zm-.071-.248c-38.88-2.156-66,11.9-60.565,31.4s41.355,37.049,80.239,39.2,66-11.9,60.567-31.4S2452.011,303.431,2413.127,301.275Z",
    transform: "translate(-2314.696 -325.102)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21265",
    "data-name": "Path 21265",
    d: "M2413.293,301.429c38.792,2.149,74.631,19.661,80.05,39.113s-21.633,33.476-60.425,31.325-74.63-19.66-80.05-39.111,21.633-33.478,60.425-31.327Zm-.069-.25c-39.064-2.165-66.309,11.961-60.851,31.548s41.552,37.224,80.616,39.391,66.308-11.961,60.851-31.547S2452.288,303.345,2413.224,301.179Z",
    transform: "translate(-2314.837 -325.173)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21266",
    "data-name": "Path 21266",
    d: "M2413.389,301.333c38.972,2.16,74.979,19.755,80.427,39.3s-21.738,33.632-60.71,31.473-74.983-19.755-80.427-39.3,21.735-33.634,60.709-31.475Zm-.069-.248c-39.248-2.175-66.619,12.016-61.135,31.7s41.746,37.4,80.991,39.571,66.619-12.013,61.136-31.7S2452.566,303.259,2413.32,301.084Z",
    transform: "translate(-2314.978 -325.244)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21267",
    "data-name": "Path 21267",
    d: "M2413.483,301.238c39.155,2.17,75.333,19.845,80.8,39.479s-21.835,33.792-60.989,31.622-75.335-19.847-80.805-39.481,21.834-33.79,60.992-31.62Zm-.067-.248c-39.43-2.186-66.929,12.07-61.42,31.843s41.938,37.568,81.367,39.755,66.926-12.072,61.418-31.843S2452.843,303.175,2413.416,300.99Z",
    transform: "translate(-2315.119 -325.314)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21268",
    "data-name": "Path 21268",
    d: "M2413.579,301.144c39.338,2.18,75.684,19.937,81.178,39.663s-21.937,33.948-61.276,31.766-75.68-19.936-81.177-39.661,21.937-33.948,61.274-31.768Zm-.07-.25c-39.61-2.194-67.235,12.127-61.7,31.988s42.135,37.745,81.746,39.941,67.234-12.126,61.7-31.988S2453.12,303.09,2413.509,300.894Z",
    transform: "translate(-2315.261 -325.385)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21269",
    "data-name": "Path 21269",
    d: "M2413.672,301.048c39.521,2.191,76.033,20.031,81.555,39.847s-22.04,34.1-61.559,31.914-76.034-20.028-81.556-39.844,22.04-34.106,61.559-31.917Zm-.066-.248c-39.794-2.2-67.548,12.183-61.985,32.138s42.324,37.915,82.116,40.121,67.546-12.181,61.987-32.136S2453.4,303.006,2413.605,300.8Z",
    transform: "translate(-2315.401 -325.455)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21270",
    "data-name": "Path 21270",
    d: "M2413.77,300.953c39.7,2.2,76.381,20.123,81.928,40.031s-22.142,34.263-61.843,32.061-76.383-20.12-81.93-40.031,22.141-34.261,61.845-32.061Zm-.071-.248c-39.974-2.215-67.854,12.239-62.269,32.284s42.519,38.09,82.493,40.305,67.855-12.237,62.272-32.284S2453.674,302.922,2413.7,300.7Z",
    transform: "translate(-2315.543 -325.526)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21271",
    "data-name": "Path 21271",
    d: "M2413.864,300.859c39.884,2.212,76.735,20.215,82.305,40.213s-22.243,34.421-62.125,32.209-76.736-20.215-82.307-40.212,22.243-34.421,62.126-32.211Zm-.069-.248c-40.158-2.227-68.163,12.294-62.553,32.431s42.714,38.262,82.871,40.489,68.162-12.294,62.552-32.429S2453.953,302.836,2413.795,300.611Z",
    transform: "translate(-2315.684 -325.596)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21272",
    "data-name": "Path 21272",
    d: "M2413.959,300.765c40.065,2.22,77.083,20.307,82.681,40.4s-22.345,34.575-62.411,32.356-77.083-20.309-82.684-40.4,22.349-34.577,62.414-32.357Zm-.068-.25c-40.342-2.236-68.474,12.351-62.838,32.579s42.908,38.438,83.246,40.672,68.474-12.348,62.837-32.575S2454.229,302.753,2413.891,300.515Z",
    transform: "translate(-2315.825 -325.667)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21273",
    "data-name": "Path 21273",
    d: "M2414.054,300.669c40.248,2.231,77.434,20.4,83.055,40.581s-22.442,34.735-62.692,32.5-77.436-20.4-83.058-40.581,22.447-34.735,62.7-32.5Zm-.072-.248c-40.521-2.245-68.778,12.405-63.119,32.725s43.1,38.611,83.623,40.856,68.781-12.4,63.12-32.723S2454.505,302.667,2413.983,300.42Z",
    transform: "translate(-2315.966 -325.737)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21274",
    "data-name": "Path 21274",
    d: "M2414.15,300.574c40.428,2.241,77.783,20.493,83.432,40.765s-22.548,34.893-62.978,32.65-77.784-20.493-83.434-40.766,22.548-34.891,62.98-32.65Zm-.071-.247c-40.7-2.259-69.091,12.459-63.4,32.87s43.293,38.785,84,41.041,69.092-12.462,63.405-32.872S2454.784,302.58,2414.08,300.327Z",
    transform: "translate(-2316.107 -325.807)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21275",
    "data-name": "Path 21275",
    d: "M2414.243,300.479c40.613,2.25,78.136,20.585,83.811,40.949s-22.651,35.049-63.262,32.8-78.135-20.582-83.812-40.946,22.653-35.049,63.264-32.8Zm-.068-.248c-40.887-2.265-69.4,12.516-63.687,33.02s43.487,38.957,84.371,41.222,69.4-12.516,63.687-33.016S2455.058,302.5,2414.175,300.231Z",
    transform: "translate(-2316.249 -325.878)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21276",
    "data-name": "Path 21276",
    d: "M2414.338,300.385c40.8,2.26,78.485,20.675,84.187,41.132s-22.751,35.205-63.546,32.945-78.484-20.677-84.185-41.133,22.751-35.2,63.544-32.943Zm-.069-.248c-41.067-2.276-69.707,12.572-63.97,33.165s43.68,39.13,84.748,41.408,69.709-12.574,63.973-33.167S2455.337,302.413,2414.269,300.137Z",
    transform: "translate(-2316.389 -325.949)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21277",
    "data-name": "Path 21277",
    d: "M2414.434,300.289c40.979,2.272,78.839,20.771,84.562,41.318s-22.853,35.361-63.83,33.093-78.835-20.771-84.56-41.318,22.851-35.363,63.828-33.093Zm-.069-.248c-41.25-2.286-70.016,12.629-64.255,33.315s43.875,39.3,85.126,41.59,70.018-12.629,64.253-33.311S2455.616,302.327,2414.364,300.041Z",
    transform: "translate(-2316.531 -326.02)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21278",
    "data-name": "Path 21278",
    d: "M2414.528,300.195c41.158,2.281,79.187,20.863,84.939,41.5s-22.957,35.519-64.114,33.24-79.187-20.861-84.938-41.5,22.955-35.519,64.113-33.238Zm-.069-.248c-41.432-2.295-70.325,12.685-64.538,33.461s44.07,39.477,85.5,41.774,70.327-12.683,64.538-33.459S2455.894,302.243,2414.459,299.946Z",
    transform: "translate(-2316.672 -326.09)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21279",
    "data-name": "Path 21279",
    d: "M2414.622,300.1c41.344,2.29,79.54,20.953,85.316,41.684s-23.055,35.676-64.4,33.386S2356,354.215,2350.23,333.486s23.054-35.677,64.392-33.386Zm-.066-.248c-41.614-2.307-70.636,12.74-64.824,33.606s44.264,39.654,85.877,41.958,70.636-12.738,64.823-33.6S2456.169,302.159,2414.556,299.852Z",
    transform: "translate(-2316.813 -326.16)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21280",
    "data-name": "Path 21280",
    d: "M2414.719,300.006c41.525,2.3,79.889,21.045,85.687,41.866s-23.156,35.835-64.68,33.533-79.885-21.045-85.687-41.87,23.158-35.832,64.68-33.53Zm-.07-.25c-41.8-2.316-70.945,12.8-65.1,33.754S2394,373.337,2435.8,375.652s70.945-12.794,65.1-33.752S2456.447,302.074,2414.65,299.756Z",
    transform: "translate(-2316.954 -326.231)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21281",
    "data-name": "Path 21281",
    d: "M2414.815,299.909c41.7,2.312,80.237,21.139,86.064,42.052s-23.258,35.992-64.964,33.679-80.238-21.137-86.065-42.05,23.261-35.992,64.965-33.681Zm-.068-.246c-41.979-2.326-71.254,12.85-65.392,33.9s44.651,40,86.631,42.326,71.254-12.853,65.388-33.9S2456.725,301.989,2414.747,299.663Z",
    transform: "translate(-2317.096 -326.301)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21282",
    "data-name": "Path 21282",
    d: "M2414.909,299.815c41.89,2.323,80.589,21.233,86.44,42.234S2477.99,378.2,2436.1,375.876s-80.589-21.229-86.44-42.234,23.359-36.148,65.246-33.827Zm-.066-.248c-42.163-2.337-71.567,12.909-65.677,34.047s44.845,40.175,87.006,42.51,71.561-12.909,65.672-34.047S2457,301.9,2414.843,299.567Z",
    transform: "translate(-2317.238 -326.372)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21283",
    "data-name": "Path 21283",
    d: "M2415,299.721c42.071,2.331,80.938,21.323,86.815,42.418s-23.461,36.306-65.528,33.973-80.939-21.319-86.819-42.416,23.463-36.306,65.532-33.974Zm-.069-.248c-42.342-2.347-71.871,12.964-65.956,34.195s45.038,40.345,87.379,42.694,71.874-12.962,65.958-34.195S2457.278,301.818,2414.935,299.473Z",
    transform: "translate(-2317.378 -326.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21284",
    "data-name": "Path 21284",
    d: "M2415.1,299.626c42.25,2.342,81.287,21.415,87.191,42.6s-23.564,36.464-65.817,34.122-81.288-21.415-87.19-42.6,23.564-36.462,65.816-34.12Zm-.072-.248c-42.524-2.357-72.179,13.018-66.239,34.342s45.23,40.521,87.756,42.876,72.181-13.018,66.239-34.344S2457.557,301.736,2415.029,299.378Z",
    transform: "translate(-2317.519 -326.513)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21285",
    "data-name": "Path 21285",
    d: "M2415.194,299.53c42.434,2.352,81.639,21.508,87.567,42.786s-23.665,36.62-66.1,34.268-81.64-21.507-87.57-42.784,23.666-36.622,66.1-34.27Zm-.069-.246c-42.706-2.368-72.492,13.074-66.523,34.488s45.423,40.693,88.133,43.059,72.488-13.072,66.523-34.486S2457.835,301.65,2415.125,299.284Z",
    transform: "translate(-2317.661 -326.583)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21286",
    "data-name": "Path 21286",
    d: "M2415.29,299.436c42.615,2.361,81.988,21.6,87.942,42.968s-23.765,36.78-66.381,34.417-81.989-21.6-87.944-42.97,23.765-36.776,66.383-34.415Zm-.07-.247c-42.888-2.378-72.8,13.129-66.808,34.636s45.619,40.864,88.507,43.244,72.8-13.131,66.808-34.637S2458.11,301.566,2415.221,299.189Z",
    transform: "translate(-2317.801 -326.654)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21287",
    "data-name": "Path 21287",
    d: "M2415.383,299.342c42.8,2.371,82.342,21.691,88.322,43.152s-23.869,36.936-66.664,34.563-82.342-21.694-88.32-43.152,23.865-36.936,66.662-34.563Zm-.067-.248c-43.071-2.387-73.111,13.186-67.09,34.783s45.81,41.042,88.883,43.428,73.108-13.186,67.09-34.785S2458.388,301.48,2415.315,299.093Z",
    transform: "translate(-2317.942 -326.725)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21288",
    "data-name": "Path 21288",
    d: "M2415.481,299.247c42.98,2.382,82.687,21.784,88.694,43.335s-23.969,37.094-66.949,34.71-82.69-21.783-88.695-43.336,23.97-37.092,66.951-34.709Zm-.071-.248c-43.253-2.4-73.417,13.242-67.374,34.929s46,41.213,89.259,43.609,73.417-13.238,67.376-34.927S2458.665,301.4,2415.41,299Z",
    transform: "translate(-2318.084 -326.795)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21289",
    "data-name": "Path 21289",
    d: "M2415.576,299.153c43.16,2.392,83.04,21.876,89.069,43.519s-24.071,37.248-67.234,34.856-83.041-21.877-89.071-43.519,24.071-37.25,67.236-34.856Zm-.071-.248c-43.436-2.408-73.725,13.3-67.657,35.077s46.2,41.389,89.635,43.795,73.728-13.3,67.657-35.077S2458.941,301.312,2415.505,298.9Z",
    transform: "translate(-2318.224 -326.865)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21290",
    "data-name": "Path 21290",
    d: "M2415.67,299.056c43.345,2.4,83.389,21.969,89.447,43.7s-24.172,37.406-67.514,35-83.394-21.969-89.449-43.7,24.175-37.406,67.517-35Zm-.07-.246c-43.616-2.42-74.034,13.351-67.942,35.223s46.393,41.562,90.011,43.979,74.035-13.353,67.942-35.224S2459.219,301.226,2415.6,298.81Z",
    transform: "translate(-2318.366 -326.936)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21291",
    "data-name": "Path 21291",
    d: "M2415.766,298.962c43.527,2.413,83.739,22.062,89.824,43.885s-24.276,37.564-67.8,35.151-83.742-22.059-89.822-43.885,24.274-37.564,67.8-35.151Zm-.069-.248c-43.8-2.429-74.344,13.409-68.227,35.37s46.586,41.736,90.388,44.163,74.346-13.409,68.227-35.37S2459.5,301.143,2415.7,298.714Z",
    transform: "translate(-2318.507 -327.007)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21292",
    "data-name": "Path 21292",
    d: "M2415.862,298.868c43.708,2.422,84.09,22.153,90.2,44.071s-24.378,37.721-68.086,35.3-84.092-22.153-90.2-44.069,24.376-37.721,68.086-35.3Zm-.071-.248c-43.98-2.439-74.653,13.464-68.51,35.518s46.781,41.909,90.763,44.345,74.655-13.462,68.51-35.518S2459.773,301.057,2415.791,298.62Z",
    transform: "translate(-2318.649 -327.077)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21293",
    "data-name": "Path 21293",
    d: "M2415.957,298.772c43.89,2.432,84.442,22.246,90.573,44.253s-24.477,37.88-68.367,35.447-84.442-22.245-90.574-44.253,24.477-37.879,68.368-35.447Zm-.07-.246c-44.164-2.45-74.965,13.52-68.794,35.663s46.973,42.083,91.139,44.533,74.964-13.523,68.791-35.669S2460.052,300.971,2415.887,298.525Z",
    transform: "translate(-2318.791 -327.148)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21294",
    "data-name": "Path 21294",
    d: "M2416.05,298.678c44.074,2.443,84.795,22.34,90.952,44.437s-24.579,38.037-68.653,35.594-84.791-22.34-90.951-44.439,24.581-38.035,68.652-35.592Zm-.068-.248c-44.347-2.458-75.272,13.575-69.077,35.813s47.168,42.257,91.512,44.715,75.274-13.579,69.077-35.813S2460.329,300.888,2415.982,298.43Z",
    transform: "translate(-2318.93 -327.219)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21295",
    "data-name": "Path 21295",
    d: "M2416.148,298.583c44.251,2.451,85.14,22.43,91.323,44.621s-24.68,38.191-68.935,35.74-85.145-22.43-91.325-44.621,24.68-38.193,68.937-35.74Zm-.071-.248c-44.527-2.469-75.58,13.632-69.362,35.959s47.36,42.43,91.889,44.9,75.584-13.634,69.361-35.96S2460.606,300.8,2416.077,298.335Z",
    transform: "translate(-2319.072 -327.289)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21296",
    "data-name": "Path 21296",
    d: "M2416.243,298.488c44.435,2.463,85.49,22.526,91.7,44.8s-24.782,38.349-69.219,35.887-85.492-22.522-91.7-44.8,24.781-38.351,69.219-35.889Zm-.069-.248c-44.711-2.477-75.893,13.69-69.647,36.108s47.557,42.6,92.27,45.079,75.888-13.688,69.641-36.1S2460.883,300.718,2416.173,298.239Z",
    transform: "translate(-2319.213 -327.36)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21297",
    "data-name": "Path 21297",
    d: "M2416.335,298.394c44.62,2.472,85.846,22.614,92.081,44.986s-24.886,38.509-69.506,36.035-85.843-22.614-92.075-44.989,24.881-38.505,69.5-36.032Zm-.07-.248c-44.892-2.489-76.2,13.744-69.928,36.252s47.75,42.776,92.643,45.267,76.2-13.745,69.929-36.255S2461.16,300.633,2416.265,298.146Z",
    transform: "translate(-2319.354 -327.43)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21298",
    "data-name": "Path 21298",
    d: "M2416.432,298.3c44.8,2.484,86.193,22.708,92.451,45.173s-24.985,38.663-69.785,36.179-86.2-22.706-92.456-45.171,24.984-38.663,69.79-36.181Zm-.072-.248c-45.074-2.5-76.506,13.8-70.21,36.4s47.941,42.951,93.015,45.447,76.509-13.8,70.213-36.4S2461.435,300.548,2416.361,298.05Z",
    transform: "translate(-2319.496 -327.501)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21299",
    "data-name": "Path 21299",
    d: "M2416.527,298.2c44.982,2.493,86.544,22.8,92.831,45.354s-25.09,38.823-70.073,36.33-86.544-22.8-92.828-45.355,25.086-38.823,70.07-36.328Zm-.071-.248c-45.255-2.508-76.818,13.855-70.494,36.547s48.136,43.125,93.39,45.631,76.82-13.855,70.5-36.547S2461.714,300.464,2416.456,297.956Z",
    transform: "translate(-2319.636 -327.571)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21300",
    "data-name": "Path 21300",
    d: "M2416.621,298.108c45.166,2.505,86.9,22.892,93.206,45.539s-25.189,38.979-70.352,36.476-86.9-22.892-93.208-45.541,25.189-38.976,70.355-36.474Zm-.069-.246c-45.439-2.519-77.127,13.91-70.779,36.695s48.33,43.3,93.768,45.815,77.129-13.91,70.781-36.7S2461.991,300.378,2416.552,297.861Z",
    transform: "translate(-2319.777 -327.642)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21301",
    "data-name": "Path 21301",
    d: "M2416.717,298.014c45.348,2.514,87.246,22.984,93.58,45.725s-25.291,39.134-70.638,36.62-87.245-22.982-93.58-45.722,25.29-39.135,70.638-36.624Zm-.069-.248c-45.622-2.528-77.436,13.968-71.064,36.842s48.525,43.474,94.145,46,77.438-13.964,71.063-36.839S2462.269,300.295,2416.648,297.765Z",
    transform: "translate(-2319.918 -327.712)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21302",
    "data-name": "Path 21302",
    d: "M2416.812,297.919c45.529,2.524,87.6,23.076,93.958,45.906s-25.394,39.293-70.922,36.769-87.6-23.076-93.958-45.906,25.39-39.293,70.922-36.769Zm-.07-.248c-45.8-2.54-77.744,14.023-71.346,36.99s48.718,43.642,94.519,46.182,77.747-14.021,71.347-36.99S2462.546,300.211,2416.742,297.671Z",
    transform: "translate(-2320.06 -327.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21303",
    "data-name": "Path 21303",
    d: "M2416.906,297.825c45.713,2.533,87.947,23.168,94.333,46.091s-25.494,39.448-71.208,36.915-87.943-23.17-94.33-46.091,25.491-39.448,71.2-36.915Zm-.068-.248c-45.986-2.548-78.056,14.077-71.631,37.137s48.91,43.816,94.9,46.366,78.056-14.079,71.631-37.137S2462.822,300.125,2416.839,297.576Z",
    transform: "translate(-2320.201 -327.853)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21304",
    "data-name": "Path 21304",
    d: "M2417,297.73c45.893,2.543,88.3,23.26,94.707,46.274s-25.592,39.608-71.487,37.063-88.3-23.26-94.71-46.275,25.6-39.606,71.49-37.061Zm-.068-.248c-46.167-2.559-78.365,14.132-71.916,37.283s49.106,43.991,95.273,46.55,78.365-14.134,71.912-37.283S2463.1,300.039,2416.934,297.482Z",
    transform: "translate(-2320.342 -327.924)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21305",
    "data-name": "Path 21305",
    d: "M2417.1,297.634c46.078,2.555,88.649,23.355,95.086,46.458s-25.7,39.766-71.773,37.21-88.647-23.352-95.085-46.456,25.7-39.766,71.772-37.212Zm-.069-.247c-46.348-2.569-78.672,14.188-72.2,37.431s49.3,44.163,95.648,46.732,78.673-14.19,72.2-37.431S2463.377,299.955,2417.027,297.387Z",
    transform: "translate(-2320.484 -327.994)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21306",
    "data-name": "Path 21306",
    d: "M2417.192,297.54c46.26,2.564,89,23.444,95.46,46.642s-25.8,39.922-72.054,37.356-89-23.444-95.462-46.642,25.8-39.92,72.056-37.356Zm-.07-.248c-46.532-2.58-78.982,14.247-72.479,37.578s49.49,44.338,96.021,46.916,78.985-14.245,72.483-37.578S2463.653,299.871,2417.122,297.292Z",
    transform: "translate(-2320.625 -328.065)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21307",
    "data-name": "Path 21307",
    d: "M2417.216,297.41c46.441,2.573,89.348,23.536,95.839,46.826s-25.9,40.076-72.342,37.5-89.347-23.536-95.837-46.824,25.9-40.078,72.341-37.5Zm-.047-.165c-46.621-2.585-79.137,14.273-72.622,37.649s49.589,44.425,96.211,47.01,79.139-14.271,72.622-37.653S2463.792,299.828,2417.169,297.245Z",
    transform: "translate(-2320.695 -328.1)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViasights);
export default __webpack_public_path__ + "static/media/viasights.f1980f5c62f16176244a8a7b238391d2.svg";
export { ForwardRef as ReactComponent };